/** generated by `python manage.py export_task_types`, do not change */
import {Observable} from "rxjs";
import {APIService, TaskGeneralReviewSerializer, EventCreateUpdateSerializer, OrderIntervalSerializer, LabOrderSerializer, RXOrderSerializer, OtherOrderSerializer, EventActionSerializer, EventReviewSerializer, OrderCreateUpdateSerializer, OrderReviewActionSerializer, OrderReviewSerializer, VitalExaminationSerializer, TaskCriticalVitalSerializer, VitalReviewActionSerializer, VitalReviewSerializer, TaskLabReviewSerializer, LabReportCreateUpdateSerializer, InfectionInformationCreateUpdateSerializer, InfectionCultureSerializer, LabDetailedResultSerializer, LabResultCreateUpdateSerializer, LabTestCreateUpdateSerializer, LabTestActionSerializer, LabTestReviewSerializer, CachedICDCodeNameSerializer, SnomedConceptSerializer, OtherOrderReadSerializer, ImagingResultSerializer, CachedLabTestSynonymSerializer, LabOrderReadSerializer, DrugbankProductSimpleSerializer, RXOrderReadSerializer, ImagingResultReviewActionReadSerializer, ImagingResultReviewReadSerializer, ClinicalTestResultSerializer, ClinicalTestResultReviewActionReadSerializer, ClinicalTestResultReviewReadSerializer, PhysicianOrderActionSerializer, PhysicianOrderSerializer, TaskDxReviewSerializer, PastMedicalHxSerializer, DiagnosisCreateUpdateSerializer, DiagnosisActionSerializer, ProblemListSerializer, TaskRXReconcileSerializer, TreatmentHistoryCreateSerializer, TreatmentActionSerializer, TreatmentReviewSerializer, TaskCdaReconcileSerializer, PatientAllergyReactionCreateUpdateSerializer, PatientAllergyCreateUpdateSerializer, PatientAllergyActionSerializer, PatientAllergyReviewCreateUpdateSerializer, TaskVisitNoteSerializer, HistoryOfPresentIllnessSerializer, SocialHistorySerializer, FamilyHistorySerializer, ImagingResultCreateUpdateSerializer, ImagingResultActionSerializer, ImagingResultReviewCreateUpdateSerializer, ClinicalTestResultCreateUpdateSerializer, ClinicalTestResultActionSerializer, ClinicalTestResultReviewCreateUpdateSerializer, ConstitutionalSystemReviewSerializer, ENTOrMouthSystemReviewSerializer, EyesSystemReviewSerializer, CardiovascularSystemReviewSerializer, RespiratorySystemReviewSerializer, GastrointestinalSystemReviewSerializer, GenitourinarySystemReviewSerializer, MusculoskeletalSystemReviewSerializer, SkinSystemReviewSerializer, NeuroSystemReviewSerializer, PsychSystemReviewSerializer, HemORLymphSystemReviewSerializer, EndocrineSystemReviewSerializer, ReviewOfSystemsSerializer, GeneralExamSerializer, SkinExamSerializer, EyesExamSerializer, ENTExamSerializer, NeckExamSerializer, LungsExamSerializer, HeartExamSerializer, AbdomenExamSerializer, GUExamSerializer, MuscularExamSerializer, NeuroExamSerializer, PsychExamSerializer, StatusObservationCreateUpdateSerializer, PhysicalExaminationCreateUpdateSerializer, ImmunizationCreateUpdateSerializer, ImmunizationActionSerializer, ImmunizationReviewCreateUpdateSerializer, ProcedureRelatedDeviceCreateUpdateSerializer, ProcedureCreateUpdateSerializer, ProcedureActionSerializer, ProcedureReviewSerializer, GoalTargetCreateUpdateSerializer, GoalCreateUpdateSerializer, WoundNestedCreateSerializer, NegationReasonSerializer, PlanActionSerializer, AssessmentPlanSerializer, PatientComplexitySerializer, VisitDetailsSerializer, TaskBehavioralVisitNoteSerializer, BehavioralPastPsychiatricHistorySerializer, BehavioralSocialHistorySerializer, BehavioralFamilyHistorySerializer, BehavioralDevelopmentalHistorySerializer, BehavioralPsychosocialCircumstancesInfluencingHealthStatusSerializer, BehavioralSymptomsOfIllnessSerializer, BehavioralBaselineEvaluationSerializer, BehavioralTraumaEvaluationSerializer, BehavioralPatientAwarenessOfConsequencesOfIllnessAndBehaviorOnSerializer, BehavioralNeuroSystemReviewSerializer, BehavioralReviewOfSystemsSerializer, BehavioralMentalStatusExamAdditionalAssessmentSerializer, BehavioralMentalStatusExamCognitionSerializer, BehavioralMentalStatusExamConditionsAndSymptomsSerializer, BehavioralMentalStatusExamGeneralSerializer, BehavioralMentalStatusExamObservationSerializer, BehavioralMentalStatusExamCreateUpdateSerializer, BehavioralNeuroExamSerializer, BehavioralPhysicalExaminationCreateUpdateSerializer, TaskWoundAssessmentSerializer, WoundReasonForVisitSerializer, WoundLocationSerializer, WoundCreateSerializer, SecondaryDxIdSerializer, WoundAssessmentCreateSerializer, ICDCodeNameSerializer, DressingOrderForPartBItemSerializer, WoundActionSerializer, WoundReviewSerializer, TaskMinimalWoundAssessmentSerializer, TaskClinicNoteSerializer, TaskReasonForVisitSerializer, TaskVisitDetailSerializer, TaskCognitiveAssessmentSerializer, CognitiveReasonForVisitSerializer, CognitiveSymptomsOfIllnessSerializer, CognitiveBaselineEvaluationSerializer, PHQ9Serializer, CognitiveFastScreeningSerializer, CognitiveCarePlanSerializer, TaskDxsVisitDetailsSerializer, TaskUrgentAcute, TaskGPCNarrative, TaskPhysicianOrderSerializer, TaskQuestionnaireSerializer, FHIRQuestionnaireResponseItemSerializer, FHIRQuestionnaireResponseSerializer, TaskClinicalStatusReviewSerializer, TaskAdmissionReviewSerializer, TaskReferralNoteSerializer, TaskPatientComplexitySerializer, ChartAuditSerializer, TaskBehavioralChartAuditSerializer, TaskTherapeuticInteractionReviewSerializer, TaskPCMReview, TaskDemographicsSerializer, PatientAdditionalNameSerializer, PatientInformationSerializer, DemographicsSerializer} from "./api.service";

export interface TaskTypeDefinition {
	name: string;
    key?: string;
    default_duration?: number;
    need_to_fax?: boolean;
    need_to_sms?: boolean;
    roles?: string[];
    billing_code_category?: number;
    placeholder_billing_description?: string;
    placeholder_note_description?: string;
    children?: TaskTypeDefinition[];
    extra_fields?: TaskTypeFields;
    is_behavioral?: boolean;
    is_visit?: boolean;
    is_progress_note?: boolean;
    deprecated?: boolean;
}

export interface TaskTypeField<T = any> {
    key: keyof T;
    label: string;
    required: boolean;
    type?: 'text' | 'number' | 'boolean' | 'date' | 'datetime' | 'textarea' | 'checkbox' | 'foreign_key_select' | 'select' | 'field_set';
    icon?: string;
    multiple?: boolean;
    choices?: { key: string, label: string }[];
    viewset?: any;
    activate_fields_on_select?: any;
    fields?: TaskTypeFields;
    apply_on_list?: () => Observable<any>;
    placeholder?: string;
    hint?: string;
    style?: string;
    disabled?: boolean;
    deprecated?: boolean;
    regex?: string;
    _class?: string;
}

export type TaskTypeFields<T = any> = TaskTypeField<T>[];

export const EventCreateUpdate: TaskTypeFields<EventCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: false,
		type: 'number',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'end_date',
		label: 'End date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'type',
		label: 'Type',
		multiple: false,
		required: true,
		type: 'text',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: true,
		type: 'foreign_key_select',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'evaluation',
		label: 'Evaluation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sub_type',
		label: 'Sub type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'physician',
		label: 'Physician',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'original_id',
		label: 'Original id',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const OrderInterval: TaskTypeFields<OrderIntervalSerializer> = [
	{
		icon: 'history',
		key: 'amount',
		label: 'Amount',
		required: false,
		type: 'number',
	},
	{
		choices: [
			{
				key: 'M',
				label: 'Minute(s)',
			},
			{
				key: 'H',
				label: 'Hour(s)',
			},
			{
				key: 'D',
				label: 'Day(s)',
			},
			{
				key: 'W',
				label: 'Week(s)',
			}
		],
		icon: 'history',
		key: 'measure',
		label: 'Measure',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'Mon',
				label: 'Monday',
			},
			{
				key: 'Tue',
				label: 'Tuesday',
			},
			{
				key: 'Wed',
				label: 'Wednesday',
			},
			{
				key: 'Thu',
				label: 'Thursday',
			},
			{
				key: 'Fri',
				label: 'Friday',
			},
			{
				key: 'Sat',
				label: 'Saturday',
			},
			{
				key: 'Sun',
				label: 'Sunday',
			},
			{
				key: 'WD',
				label: 'Weekdays',
			},
			{
				key: 'WE',
				label: 'Weekend',
			}
		],
		key: 'days',
		label: 'Days',
		multiple: true,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'AM',
				label: 'Morning',
			},
			{
				key: 'PM',
				label: 'Evening',
			},
			{
				key: 'SHIFT',
				label: '8-hour shift',
			}
		],
		icon: 'clock',
		key: 'period_of_day',
		label: 'Period of day',
		multiple: false,
		required: false,
		type: 'select',
	}
];

export const LabOrder: TaskTypeFields<LabOrderSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		icon: 'stethoscope',
		key: 'related_icd_diagnoses',
		label: 'Related icd diagnoses',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	},
	{
		icon: 'vials',
		key: 'lab_test_synonym',
		label: 'Lab test synonym',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		choices: [
			{
				key: 'STAT',
				label: 'STAT',
			},
			{
				key: 'ASAP',
				label: 'ASAP',
			},
			{
				key: 'ROUTINE',
				label: 'Routine',
			}
		],
		icon: 'exclamation-circle',
		key: 'urgency',
		label: 'Urgency',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		icon: 'calendar',
		key: 'start',
		label: 'Start',
		required: false,
		type: 'date',
	},
	{
		_class: 'OrderInterval',
		fields: OrderInterval,
		icon: 'redo',
		key: 'order_interval',
		label: 'Recurring every',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		icon: 'calendar-times',
		key: 'end',
		label: 'End',
		required: false,
		type: 'date',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'order_id',
		label: 'Order id',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'barcode',
		label: 'Barcode',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'user',
		label: 'User',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const RXOrder: TaskTypeFields<RXOrderSerializer> = [
	{
		key: 'drugbank_product',
		label: 'Drugbank product',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'medication',
		label: 'Medication',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'amount',
		label: 'Amount',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'instructions',
		label: 'Instructions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'related_icd_diagnoses',
		label: 'Related icd diagnoses',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'start',
		label: 'Start',
		required: false,
		type: 'date',
	},
	{
		key: 'end',
		label: 'End',
		required: false,
		type: 'date',
	},
	{
		key: 'drug_code',
		label: 'Drug code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'disp_amount',
		label: 'Disp amount',
		required: false,
		type: 'number',
	},
	{
		key: 'disp_units',
		label: 'Disp units',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'quantity',
		label: 'Quantity',
		required: false,
		type: 'number',
	},
	{
		key: 'dosage',
		label: 'Dosage',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dosage_uid',
		label: 'Dosage uid',
		required: false,
		type: 'number',
	},
	{
		key: 'freq',
		label: 'Freq',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'duration',
		label: 'Duration',
		required: false,
		type: 'number',
	},
	{
		key: 'refills',
		label: 'Refills',
		required: false,
		type: 'number',
	},
	{
		key: 'earliest_fill_date',
		label: 'Earliest fill date',
		required: false,
		type: 'date',
	},
	{
		key: 'substitution_allowed',
		label: 'Substitution allowed',
		required: false,
		type: 'boolean',
	},
	{
		key: 'notes',
		label: 'Notes',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'e_prescribing_status',
		label: 'E prescribing status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'controlled_substance',
		label: 'Controlled substance',
		required: false,
		type: 'boolean',
	},
	{
		key: 'route',
		label: 'Route',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pharmacy',
		label: 'Pharmacy',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const OtherOrder: TaskTypeFields<OtherOrderSerializer> = [
	{
		choices: [
			{
				key: 'GENERAL',
				label: 'General',
			},
			{
				key: 'DIETARY',
				label: 'Dietary',
			},
			{
				key: 'RADIOLOGY',
				label: 'Radiology',
			},
			{
				key: 'SPECIALIST_APPOINTMENT',
				label: 'Specialist Appointment',
			},
			{
				key: 'VITAL_CAPTURE_FREQUENCY',
				label: 'Vital Capture Frequency',
			},
			{
				key: 'ENTERED_INTO_FACILITY_EMR',
				label: 'Entered into Facility EMR',
			}
		],
		key: 'type',
		label: 'Type',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'related_icd_diagnoses',
		label: 'Related icd diagnoses',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'snomed_concept',
		label: 'Snomed concept',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'related_snomed_diagnosis',
		label: 'Related snomed diagnosis',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const EventAction: TaskTypeFields<EventActionSerializer> = [
	{
		_class: 'EventCreateUpdate',
		fields: EventCreateUpdate,
		key: 'event',
		label: 'Event',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const EventReview: TaskTypeFields<EventReviewSerializer> = [
	{
		key: 'review',
		label: 'Review',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'EventAction',
		fields: EventAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	},
	{
		key: 'falls',
		label: 'Falls',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'wounds',
		label: 'Wounds',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'diet',
		label: 'Diet',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'infections',
		label: 'Infections',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const OrderCreateUpdate: TaskTypeFields<OrderCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: false,
		type: 'number',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'flow_sheet_type',
		label: 'Flow sheet type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'order_type',
		label: 'Order type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'order_date',
		label: 'Order date',
		required: false,
		type: 'date',
	},
	{
		key: 'start_date',
		label: 'Start date',
		required: false,
		type: 'date',
	},
	{
		key: 'end_date',
		label: 'End date',
		required: false,
		type: 'date',
	},
	{
		key: 'end_date_expected',
		label: 'End date expected',
		required: false,
		type: 'date',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'physician',
		label: 'Physician',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'original_id',
		label: 'Original id',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'indications_for_use',
		label: 'Indications for use',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	}
];

export const OrderReviewAction: TaskTypeFields<OrderReviewActionSerializer> = [
	{
		_class: 'OrderCreateUpdate',
		fields: OrderCreateUpdate,
		key: 'order',
		label: 'Order',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'REVIEW',
				label: 'Review',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	}
];

export const OrderReview: TaskTypeFields<OrderReviewSerializer> = [
	{
		_class: 'OrderReviewAction',
		apply_on_list: APIService.OrderViewSet.list,
		fields: OrderReviewAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	}
];

export const VitalExamination: TaskTypeFields<VitalExaminationSerializer> = [
	{
		key: 'blood_pressure_value',
		label: 'Blood pressure value',
		required: false,
		type: 'number',
	},
	{
		key: 'blood_pressure_value_secondary',
		label: 'Blood pressure value secondary',
		required: false,
		type: 'number',
	},
	{
		key: 'blood_pressure_comment',
		label: 'Blood pressure comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pulse_value',
		label: 'Pulse value',
		required: false,
		type: 'number',
	},
	{
		key: 'pulse_comment',
		label: 'Pulse comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'temperature_value',
		label: 'Temperature value',
		required: false,
		type: 'number',
	},
	{
		key: 'temperature_comment',
		label: 'Temperature comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'respirations_value',
		label: 'Respirations value',
		required: false,
		type: 'number',
	},
	{
		key: 'respirations_comment',
		label: 'Respirations comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'o2_saturation_value',
		label: 'O2 saturation value',
		required: false,
		type: 'number',
	},
	{
		key: 'o2_saturation_comment',
		label: 'O2 saturation comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'blood_sugar_value',
		label: 'Blood sugar value',
		required: false,
		type: 'number',
	},
	{
		key: 'blood_sugar_comment',
		label: 'Blood sugar comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'weight_value',
		label: 'Weight value',
		required: false,
		type: 'number',
	},
	{
		key: 'weight_comment',
		label: 'Weight comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'height_value',
		label: 'Height value',
		required: false,
		type: 'number',
	},
	{
		key: 'height_comment',
		label: 'Height comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pediatric_head_circumference_percentile_value',
		label: 'Pediatric head circumference percentile value',
		required: false,
		type: 'number',
	},
	{
		key: 'pediatric_head_circumference_percentile_comment',
		label: 'Pediatric head circumference percentile comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'head_circumference_value',
		label: 'Head circumference value',
		required: false,
		type: 'number',
	},
	{
		key: 'head_circumference_comment',
		label: 'Head circumference comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pediatric_bmi_for_age_percentile_value',
		label: 'Pediatric bmi for age percentile value',
		required: false,
		type: 'number',
	},
	{
		key: 'pediatric_bmi_for_age_percentile_comment',
		label: 'Pediatric bmi for age percentile comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pediatric_weight_for_height_percentile_value',
		label: 'Pediatric weight for height percentile value',
		required: false,
		type: 'number',
	},
	{
		key: 'pediatric_weight_for_height_percentile_comment',
		label: 'Pediatric weight for height percentile comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'F',
				label: '°F',
			},
			{
				key: 'C',
				label: '°C',
			}
		],
		key: 'temperature_unit',
		label: 'Temperature unit',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'lb',
				label: 'lb',
			},
			{
				key: 'kg',
				label: 'kg',
			}
		],
		key: 'weight_unit',
		label: 'Weight unit',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'in',
				label: 'in',
			},
			{
				key: 'cm',
				label: 'cm',
			}
		],
		key: 'height_unit',
		label: 'Height unit',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'inhaled_oxygen_concentration_value',
		label: 'Inhaled oxygen concentration value',
		required: false,
		type: 'number',
	},
	{
		key: 'inhaled_oxygen_concentration_comment',
		label: 'Inhaled oxygen concentration comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'inhaled_oxygen_flow_rate_value',
		label: 'Inhaled oxygen flow rate value',
		required: false,
		type: 'number',
	},
	{
		key: 'inhaled_oxygen_flow_rate_comment',
		label: 'Inhaled oxygen flow rate comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'bmi_value',
		label: 'Bmi value',
		required: false,
		type: 'number',
	},
	{
		key: 'bmi_comment',
		label: 'Bmi comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'bmi_screening',
		label: 'Bmi screening',
		required: false,
		type: 'boolean',
	},
	{
		key: 'bmi_negation_reason',
		label: 'Bmi negation reason',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'recorded',
		label: 'Recorded',
		required: false,
	}
];

export const VitalReviewAction: TaskTypeFields<VitalReviewActionSerializer> = [
	{
		key: 'vital',
		label: 'Vital',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const VitalReview: TaskTypeFields<VitalReviewSerializer> = [
	{
		_class: 'VitalReviewAction',
		fields: VitalReviewAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	}
];

export const LabReportCreateUpdate: TaskTypeFields<LabReportCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'order_id',
		label: 'Order id',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'status',
		label: 'Status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'physician',
		label: 'Physician',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'collected_date',
		label: 'Collected date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'resulted_date',
		label: 'Resulted date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'origin',
		label: 'Origin',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'reporting_laboratories',
		label: 'Reporting laboratories',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lab_provider',
		label: 'Lab provider',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'performing_locations',
		label: 'Performing locations',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'specimen_collector',
		label: 'Specimen collector',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'received_date',
		label: 'Received date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'emr_upload_status',
		label: 'Emr upload status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'emr_upload_id',
		label: 'Emr upload id',
		required: false,
		type: 'number',
	},
	{
		key: 'notifications_sent',
		label: 'Notifications sent',
		required: false,
		type: 'boolean',
	}
];

export const InfectionInformationCreateUpdate: TaskTypeFields<InfectionInformationCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'infection',
		label: 'Infection',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'infection_site',
		label: 'Infection site',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'symptom_onset_date',
		label: 'Symptom onset date',
		required: false,
		type: 'date',
	},
	{
		key: 'type_of_acquisition',
		label: 'Type of acquisition',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'type_of_isolation',
		label: 'Type of isolation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'date_of_order',
		label: 'Date of order',
		required: false,
		type: 'datetime',
	},
	{
		key: 'date_of_result',
		label: 'Date of result',
		required: false,
		type: 'datetime',
	},
	{
		key: 'confirmed',
		label: 'Confirmed',
		required: true,
		type: 'boolean',
	},
	{
		key: 'resolved',
		label: 'Resolved',
		required: false,
		type: 'date',
	},
	{
		key: 'icd',
		label: 'Icd',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'recurrence_days',
		label: 'Recurrence days',
		required: false,
		type: 'number',
	}
];

export const InfectionCulture: TaskTypeFields<InfectionCultureSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'name',
		label: 'Name',
		multiple: false,
		required: true,
		type: 'text',
	},
	{
		key: 'organization',
		label: 'Organization',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'classification',
		label: 'Classification',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const LabDetailedResult: TaskTypeFields<LabDetailedResultSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'susceptibility',
		label: 'Susceptibility',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'interpretation',
		label: 'Interpretation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'mic',
		label: 'Mic',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	}
];

export const LabResultCreateUpdate: TaskTypeFields<LabResultCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		_class: 'LabReportCreateUpdate',
		fields: LabReportCreateUpdate,
		key: 'lab_report',
		label: 'Lab report',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'lab_test',
		label: 'Lab test',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'culture_type',
		label: 'Culture type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'flag',
		label: 'Flag',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'quantity',
		label: 'Quantity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'unit',
		label: 'Unit',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'ref_range',
		label: 'Ref range',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'InfectionCulture',
		fields: InfectionCulture,
		key: 'infection_culture',
		label: 'Infection culture',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'is_abnormal',
		label: 'Is abnormal',
		required: false,
		type: 'boolean',
	},
	{
		_class: 'LabDetailedResult',
		fields: LabDetailedResult,
		key: 'lab_detailed_results',
		label: 'Lab detailed results',
		multiple: true,
		required: false,
		type: 'field_set',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'status',
		label: 'Status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'is_critical',
		label: 'Is critical',
		required: false,
		type: 'boolean',
	},
	{
		key: 'is_inconclusive',
		label: 'Is inconclusive',
		required: false,
		type: 'boolean',
	},
	{
		key: 'is_no_result',
		label: 'Is no result',
		required: false,
		type: 'boolean',
	},
	{
		key: 'mdro',
		label: 'Mdro',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'code',
		label: 'Code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'loinc_code',
		label: 'Loinc code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'snomed_code',
		label: 'Snomed code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'effective_time',
		label: 'Effective time',
		required: false,
		type: 'datetime',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'critical_notifications_sent',
		label: 'Critical notifications sent',
		required: false,
		type: 'boolean',
	}
];

export const LabTestCreateUpdate: TaskTypeFields<LabTestCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'name',
		label: 'Name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lab_type',
		label: 'Lab type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'LabReportCreateUpdate',
		fields: LabReportCreateUpdate,
		key: 'lab_report',
		label: 'Lab report',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'InfectionInformationCreateUpdate',
		fields: InfectionInformationCreateUpdate,
		key: 'infection_information',
		label: 'Infection information',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'source',
		label: 'Source',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'LabResultCreateUpdate',
		fields: LabResultCreateUpdate,
		key: 'lab_results',
		label: 'Lab results',
		multiple: true,
		required: false,
		type: 'field_set',
	},
	{
		key: 'collected_date',
		label: 'Collected date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'resulted_date',
		label: 'Resulted date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'status',
		label: 'Status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'code',
		label: 'Code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'loinc_code',
		label: 'Loinc code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'critical_notifications_sent',
		label: 'Critical notifications sent',
		required: false,
		type: 'boolean',
	},
	{
		key: 'corrected_notifications_sent',
		label: 'Corrected notifications sent',
		required: false,
		type: 'boolean',
	}
];

export const LabTestAction: TaskTypeFields<LabTestActionSerializer> = [
	{
		_class: 'LabTestCreateUpdate',
		fields: LabTestCreateUpdate,
		key: 'lab_test',
		label: 'Lab test',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const LabTestReview: TaskTypeFields<LabTestReviewSerializer> = [
	{
		_class: 'LabTestAction',
		apply_on_list: APIService.LabTestViewSet.list,
		fields: LabTestAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	},
	{
		key: 'comments',
		label: 'Lab Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'x_ray_review',
		label: 'X-ray Review',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const CachedICDCodeName: TaskTypeFields<CachedICDCodeNameSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'name',
		label: 'Name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const SnomedConcept: TaskTypeFields<SnomedConceptSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: true,
	},
	{
		key: 'term',
		label: 'Term',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const OtherOrderRead: TaskTypeFields<OtherOrderReadSerializer> = [
	{
		choices: [
			{
				key: 'GENERAL',
				label: 'General',
			},
			{
				key: 'DIETARY',
				label: 'Dietary',
			},
			{
				key: 'RADIOLOGY',
				label: 'Radiology',
			},
			{
				key: 'SPECIALIST_APPOINTMENT',
				label: 'Specialist Appointment',
			},
			{
				key: 'VITAL_CAPTURE_FREQUENCY',
				label: 'Vital Capture Frequency',
			},
			{
				key: 'ENTERED_INTO_FACILITY_EMR',
				label: 'Entered into Facility EMR',
			}
		],
		key: 'type',
		label: 'Type',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'CachedICDCodeName',
		fields: CachedICDCodeName,
		key: 'related_icd_diagnoses',
		label: 'Related icd diagnoses',
		multiple: true,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'SnomedConcept',
		fields: SnomedConcept,
		key: 'snomed_concept',
		label: 'Snomed concept',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'SnomedConcept',
		fields: SnomedConcept,
		key: 'related_snomed_diagnosis',
		label: 'Related snomed diagnosis',
		multiple: false,
		required: true,
		type: 'field_set',
	}
];

export const ImagingResult: TaskTypeFields<ImagingResultSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		choices: [
			{
				key: 'aborted',
				label: 'aborted',
			},
			{
				key: 'active',
				label: 'active',
			},
			{
				key: 'cancelled',
				label: 'cancelled',
			},
			{
				key: 'completed',
				label: 'completed',
			},
			{
				key: 'held',
				label: 'held',
			},
			{
				key: 'new',
				label: 'new',
			},
			{
				key: 'normal',
				label: 'normal',
			},
			{
				key: 'nullified',
				label: 'nullified',
			},
			{
				key: 'obsolete',
				label: 'obsolete',
			},
			{
				key: 'suspended',
				label: 'suspended',
			}
		],
		key: 'status',
		label: 'Status',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'code',
		label: 'Code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'code_display',
		label: 'Code display',
		required: false,
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'date',
	},
	{
		key: 'value_code',
		label: 'Value code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_code_display',
		label: 'Value code display',
		required: false,
	},
	{
		key: 'value_string',
		label: 'Value string',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_quantity',
		label: 'Value quantity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'unit',
		label: 'Unit',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'OtherOrderRead',
		fields: OtherOrderRead,
		key: 'order',
		label: 'Order',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'sub_category',
		label: 'Sub category',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'examination_date',
		label: 'Examination date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'reported_date',
		label: 'Reported date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'imaging_order_id',
		label: 'Imaging order id',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'reporting_clinic',
		label: 'Reporting clinic',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'interpretation',
		label: 'Interpretation',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const CachedLabTestSynonym: TaskTypeFields<CachedLabTestSynonymSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'name',
		label: 'Name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lab_code',
		label: 'Lab code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'display_name',
		label: 'Display name',
		required: false,
	}
];

export const LabOrderRead: TaskTypeFields<LabOrderReadSerializer> = [
	{
		_class: 'CachedICDCodeName',
		fields: CachedICDCodeName,
		icon: 'stethoscope',
		key: 'related_icd_diagnoses',
		label: 'Related icd diagnoses',
		multiple: true,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'CachedLabTestSynonym',
		fields: CachedLabTestSynonym,
		icon: 'vials',
		key: 'lab_test_synonym',
		label: 'Lab test synonym',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'STAT',
				label: 'STAT',
			},
			{
				key: 'ASAP',
				label: 'ASAP',
			},
			{
				key: 'ROUTINE',
				label: 'Routine',
			}
		],
		icon: 'exclamation-circle',
		key: 'urgency',
		label: 'Urgency',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		icon: 'calendar',
		key: 'start',
		label: 'Start',
		required: false,
		type: 'date',
	},
	{
		_class: 'OrderInterval',
		fields: OrderInterval,
		icon: 'redo',
		key: 'order_interval',
		label: 'Recurring every',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		icon: 'calendar-times',
		key: 'end',
		label: 'End',
		required: false,
		type: 'date',
	}
];

export const DrugbankProductSimple: TaskTypeFields<DrugbankProductSimpleSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: true,
	},
	{
		key: 'name',
		label: 'Name',
		multiple: false,
		required: true,
		type: 'text',
	},
	{
		key: 'drug',
		label: 'Drug',
		required: false,
	},
	{
		key: 'prescribable_name',
		label: 'Prescribable name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dosage_form',
		label: 'Dosage form',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'route',
		label: 'Route',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'schedule',
		label: 'Schedule',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'ayva_ddid',
		label: 'Ayva ddid',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'legacy_name',
		label: 'Legacy name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'usage_count',
		label: 'Usage count',
		required: false,
		type: 'number',
	}
];

export const RXOrderRead: TaskTypeFields<RXOrderReadSerializer> = [
	{
		icon: 'pills',
		key: 'medication',
		label: 'Medication',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		icon: 'tachometer',
		key: 'amount',
		label: 'Amount',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		icon: 'clipboard-list',
		key: 'instructions',
		label: 'Instructions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'CachedICDCodeName',
		fields: CachedICDCodeName,
		key: 'related_icd_diagnoses',
		label: 'Related icd diagnoses',
		multiple: true,
		required: true,
		type: 'field_set',
	},
	{
		key: 'start',
		label: 'Start',
		required: false,
		type: 'date',
	},
	{
		key: 'end',
		label: 'End',
		required: false,
		type: 'date',
	},
	{
		key: 'drug_code',
		label: 'Drug code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'disp_amount',
		label: 'Disp amount',
		required: false,
		type: 'number',
	},
	{
		key: 'disp_units',
		label: 'Disp units',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'quantity',
		label: 'Quantity',
		required: false,
		type: 'number',
	},
	{
		key: 'dosage',
		label: 'Dosage',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dosage_uid',
		label: 'Dosage uid',
		required: false,
		type: 'number',
	},
	{
		key: 'freq',
		label: 'Freq',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'duration',
		label: 'Duration',
		required: false,
		type: 'number',
	},
	{
		key: 'refills',
		label: 'Refills',
		required: false,
		type: 'number',
	},
	{
		key: 'earliest_fill_date',
		label: 'Earliest fill date',
		required: false,
		type: 'date',
	},
	{
		key: 'substitution_allowed',
		label: 'Substitution allowed',
		required: false,
		type: 'boolean',
	},
	{
		key: 'notes',
		label: 'Notes',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'e_prescribing_status',
		label: 'E prescribing status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'controlled_substance',
		label: 'Controlled substance',
		required: false,
		type: 'boolean',
	},
	{
		key: 'route',
		label: 'Route',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pharmacy',
		label: 'Pharmacy',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'DrugbankProductSimple',
		fields: DrugbankProductSimple,
		key: 'drugbank_product',
		label: 'Drugbank product',
		multiple: false,
		required: true,
		type: 'field_set',
	}
];

export const ImagingResultReviewActionRead: TaskTypeFields<ImagingResultReviewActionReadSerializer> = [
	{
		_class: 'ImagingResult',
		fields: ImagingResult,
		key: 'imaging_result',
		label: 'Imaging result',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'LabOrderRead',
		fields: LabOrderRead,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'RXOrderRead',
		fields: RXOrderRead,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'OtherOrderRead',
		fields: OtherOrderRead,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const ImagingResultReviewRead: TaskTypeFields<ImagingResultReviewReadSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'review',
		label: 'Review',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'ImagingResultReviewActionRead',
		fields: ImagingResultReviewActionRead,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	}
];

export const ClinicalTestResult: TaskTypeFields<ClinicalTestResultSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		choices: [
			{
				key: 'aborted',
				label: 'aborted',
			},
			{
				key: 'active',
				label: 'active',
			},
			{
				key: 'cancelled',
				label: 'cancelled',
			},
			{
				key: 'completed',
				label: 'completed',
			},
			{
				key: 'held',
				label: 'held',
			},
			{
				key: 'new',
				label: 'new',
			},
			{
				key: 'normal',
				label: 'normal',
			},
			{
				key: 'nullified',
				label: 'nullified',
			},
			{
				key: 'obsolete',
				label: 'obsolete',
			},
			{
				key: 'suspended',
				label: 'suspended',
			}
		],
		key: 'status',
		label: 'Status',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'code',
		label: 'Code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'code_display',
		label: 'Code display',
		required: false,
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'date',
	},
	{
		key: 'value_code',
		label: 'Value code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_code_display',
		label: 'Value code display',
		required: false,
	},
	{
		key: 'value_string',
		label: 'Value string',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_quantity',
		label: 'Value quantity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'unit',
		label: 'Unit',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'OtherOrderRead',
		fields: OtherOrderRead,
		key: 'order',
		label: 'Order',
		multiple: false,
		required: true,
		type: 'field_set',
	}
];

export const ClinicalTestResultReviewActionRead: TaskTypeFields<ClinicalTestResultReviewActionReadSerializer> = [
	{
		_class: 'ClinicalTestResult',
		fields: ClinicalTestResult,
		key: 'clinical_test_result',
		label: 'Clinical test result',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'LabOrderRead',
		fields: LabOrderRead,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'RXOrderRead',
		fields: RXOrderRead,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'OtherOrderRead',
		fields: OtherOrderRead,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const ClinicalTestResultReviewRead: TaskTypeFields<ClinicalTestResultReviewReadSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'review',
		label: 'Review',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'ClinicalTestResultReviewActionRead',
		fields: ClinicalTestResultReviewActionRead,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	}
];

export const PhysicianOrderAction: TaskTypeFields<PhysicianOrderActionSerializer> = [
	{
		key: 'assessment_plan',
		label: 'Assessment plan',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		choices: [
			{
				key: 'ADD',
				label: 'Add to Problem List',
			},
			{
				key: 'ACTIVE',
				label: 'Active',
			},
			{
				key: 'ACUTE',
				label: 'Acute',
			},
			{
				key: 'RESOLVED',
				label: 'Resolved',
			},
			{
				key: 'DORMANT',
				label: 'Dormant',
			},
			{
				key: 'INSUFFICIENT',
				label: 'Insufficient',
			},
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'COMMENT',
				label: 'Care Plan',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'UPDATE_ICD',
				label: 'Update ICD-10',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			},
			{
				key: 'GOAL',
				label: 'Goal',
			},
			{
				key: 'HEALTH_CONCERN',
				label: 'Health Concern',
			},
			{
				key: 'PROCEDURE_ORDER',
				label: 'Procedure Order',
			},
			{
				key: 'NEGATION_REASON',
				label: 'Negation Reason',
			},
			{
				key: 'WOUND_REVIEW',
				label: 'Wound review',
			},
			{
				key: 'DRESSING_ORDER',
				label: 'Dressing order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'event',
		label: 'Event',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'vital',
		label: 'Vital',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'treatment_history',
		label: 'Treatment history',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'lab_test',
		label: 'Lab test',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'icd',
		label: 'Icd',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'icd_update',
		label: 'Icd update',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'diagnosis',
		label: 'Diagnosis',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const PhysicianOrder: TaskTypeFields<PhysicianOrderSerializer> = [
	{
		_class: 'PhysicianOrderAction',
		fields: PhysicianOrderAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	}
];

export const PastMedicalHx: TaskTypeFields<PastMedicalHxSerializer> = [
	{
		key: 'reason_for_admission',
		label: 'Reason for admission',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'history_of_surgery_procedures',
		label: 'History of surgery procedures',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dietary_restrictions',
		label: 'Dietary restrictions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'primary_diagnosis',
		label: 'Primary diagnosis',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'primary_diagnosis_comment',
		label: 'Primary diagnosis comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const DiagnosisCreateUpdate: TaskTypeFields<DiagnosisCreateUpdateSerializer> = [
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'icd',
		label: 'Icd',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'date_diagnosed',
		label: 'Date diagnosed',
		required: false,
		type: 'date',
	},
	{
		key: 'date_resolved',
		label: 'Date resolved',
		required: false,
		type: 'date',
	},
	{
		key: 'snomed_concept',
		label: 'Snomed concept',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'is_health_concern',
		label: 'Is health concern',
		required: false,
		type: 'boolean',
	},
	{
		key: 'associated_health_concern',
		label: 'Associated health concern',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'category',
		label: 'Category',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient_document',
		label: 'Patient document',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'modified_at',
		label: 'Modified at',
		required: false,
		type: 'datetime',
	}
];

export const DiagnosisAction: TaskTypeFields<DiagnosisActionSerializer> = [
	{
		_class: 'DiagnosisCreateUpdate',
		fields: DiagnosisCreateUpdate,
		key: 'diagnosis',
		label: 'Diagnosis',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'UPDATE_ICD',
				label: 'Update ICD',
			},
			{
				key: 'ADD',
				label: 'Add to Problem List',
			},
			{
				key: 'ACTIVE',
				label: 'Active',
			},
			{
				key: 'ACUTE',
				label: 'Acute',
			},
			{
				key: 'RESOLVED',
				label: 'Resolved',
			},
			{
				key: 'DORMANT',
				label: 'Dormant',
			},
			{
				key: 'INSUFFICIENT',
				label: 'Insufficient',
			},
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'COMMENT',
				label: 'Care Plan',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			},
			{
				key: 'HEALTH_CONCERN',
				label: 'Health Concern',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'icd',
		label: 'Icd',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
		viewset: APIService.ICDCodeViewSet,
	},
	{
		key: 'icd_update',
		label: 'Icd update',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'snomed_concept',
		label: 'Snomed concept',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		choices: [
			{
				key: 'IN_EXACERBATION',
				label: 'In exacerbation',
			},
			{
				key: 'ACTIVELY_MONITORING',
				label: 'Actively monitoring',
			},
			{
				key: 'WORSENING',
				label: 'Worsening',
			},
			{
				key: 'CHRONIC_MANAGED',
				label: 'Chronic, managed',
			},
			{
				key: 'ACTIVE',
				label: 'Active',
			},
			{
				key: 'RESOLVED',
				label: 'Resolved',
			}
		],
		key: 'disease_status',
		label: 'Disease status',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const ProblemList: TaskTypeFields<ProblemListSerializer> = [
	{
		_class: 'DiagnosisAction',
		fields: DiagnosisAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	},
	{
		key: 'no_known_problems',
		label: 'No known problems',
		required: false,
		type: 'boolean',
	}
];

export const TreatmentHistoryCreate: TaskTypeFields<TreatmentHistoryCreateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'infection_information',
		label: 'Infection information',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'drug',
		label: 'Drug',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'amount',
		label: 'Amount',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'instructions',
		label: 'Instructions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'start_date',
		label: 'Start date',
		required: false,
		type: 'date',
	},
	{
		key: 'end_date',
		label: 'End date',
		required: false,
		type: 'date',
	},
	{
		key: 'parent',
		label: 'Parent',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'drug_name',
		label: 'Drug name',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'drugbank_product',
		label: 'Drugbank product',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'rx_norm_code',
		label: 'Rx norm code',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'physician',
		label: 'Physician',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'icd',
		label: 'Icd',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'freq',
		label: 'Freq',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'frequency',
		label: 'Frequency',
		required: false,
		type: 'number',
	},
	{
		choices: [
			{
				key: 'M',
				label: 'Minute(s)',
			},
			{
				key: 'H',
				label: 'Hour(s)',
			},
			{
				key: 'D',
				label: 'Day(s)',
			},
			{
				key: 'W',
				label: 'Week(s)',
			}
		],
		key: 'frequency_unit',
		label: 'Frequency unit',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'AC',
				label: 'Before the meal',
			},
			{
				key: 'HS',
				label: 'Before sleep',
			},
			{
				key: 'ACD',
				label: 'Before lunch',
			},
			{
				key: 'ACM',
				label: 'Before breakfast',
			},
			{
				key: 'ACV',
				label: 'Before dinner',
			},
			{
				key: 'C',
				label: 'During meals',
			},
			{
				key: 'CD',
				label: 'During lunch',
			},
			{
				key: 'CM',
				label: 'During breakfast',
			},
			{
				key: 'CV',
				label: 'During dinner',
			},
			{
				key: 'PC',
				label: 'After the meal',
			},
			{
				key: 'PCD',
				label: 'After lunch',
			},
			{
				key: 'PCM',
				label: 'After breakfast',
			},
			{
				key: 'PCV',
				label: 'After dinner',
			},
			{
				key: 'WAKE',
				label: 'Upon waking up',
			},
			{
				key: 'PRN',
				label: 'As needed',
			}
		],
		key: 'frequency_event',
		label: 'Frequency event',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'dose_quantity',
		label: 'Dose quantity',
		required: false,
		type: 'number',
	},
	{
		key: 'dose_unit',
		label: 'Dose unit',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'route_code',
		label: 'Route code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'route_code_system',
		label: 'Route code system',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'prn',
		label: 'Prn',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'medication_class',
		label: 'Medication class',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'order_type',
		label: 'Order type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'is_infection',
		label: 'Is infection',
		required: false,
		type: 'boolean',
	},
	{
		key: 'indications_for_use',
		label: 'Indications for use',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'product_type',
		label: 'Product type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'original_id',
		label: 'Original id',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'order_date',
		label: 'Order date',
		required: false,
		type: 'date',
	},
	{
		key: 'discontinued_reason',
		label: 'Discontinued reason',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'end_date_expected',
		label: 'End date expected',
		required: false,
		type: 'date',
	},
	{
		key: 'patient_document',
		label: 'Patient document',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const TreatmentAction: TaskTypeFields<TreatmentActionSerializer> = [
	{
		_class: 'TreatmentHistoryCreate',
		fields: TreatmentHistoryCreate,
		key: 'treatment_history',
		label: 'Treatment history',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		activate_fields_on_select: {
			DISCONTINUE: [
				'comments',
			],
			REVIEW: [
				'comments',
			],
			UPDATE: [
				'comments',
			],
			UPDATE_ICD: [
				'icd_update',
			],
		},
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'UPDATE_ICD',
				label: 'Update ICD-10',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'icd',
		label: 'Icd',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'icd_update',
		label: 'Icd update',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const TreatmentReview: TaskTypeFields<TreatmentReviewSerializer> = [
	{
		_class: 'TreatmentAction',
		apply_on_list: APIService.TreatmentHistoryViewSet.list,
		fields: TreatmentAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	},
	{
		key: 'medication_hx',
		label: 'Medication hx',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'reconciliation_complete',
		label: 'Reconciliation complete',
		required: false,
		type: 'boolean',
	},
	{
		key: 'no_known_medications',
		label: 'No known medications',
		required: false,
		type: 'boolean',
	}
];

export const PatientAllergyReactionCreateUpdate: TaskTypeFields<PatientAllergyReactionCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'severity',
		label: 'Severity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'date',
	},
	{
		key: 'snomed_concept',
		label: 'Snomed concept',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'note',
		label: 'Note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const PatientAllergyCreateUpdate: TaskTypeFields<PatientAllergyCreateUpdateSerializer> = [
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'type',
		label: 'Type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sub_type',
		label: 'Sub type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'reaction_note',
		label: 'Reaction note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'severity',
		label: 'Severity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'start_date',
		label: 'Start date',
		required: false,
		type: 'date',
	},
	{
		key: 'end_date',
		label: 'End date',
		required: false,
		type: 'date',
	},
	{
		key: 'status',
		label: 'Status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'is_active',
		label: 'Is active',
		required: false,
		type: 'boolean',
	},
	{
		key: 'verification_status',
		label: 'Verification status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'allergy_type_snomed_concept',
		label: 'Allergy type snomed concept',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'snomed_concept',
		label: 'Snomed concept',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'drugbank_product_concept',
		label: 'Drugbank product concept',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'drugbank_product_concept_rxcui',
		label: 'Drugbank product concept rxcui',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'allergy',
		label: 'Allergy',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		_class: 'PatientAllergyReactionCreateUpdate',
		fields: PatientAllergyReactionCreateUpdate,
		key: 'reactions',
		label: 'Reactions',
		multiple: true,
		required: false,
		type: 'field_set',
	},
	{
		key: 'patient_document',
		label: 'Patient document',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const PatientAllergyAction: TaskTypeFields<PatientAllergyActionSerializer> = [
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		_class: 'PatientAllergyCreateUpdate',
		fields: PatientAllergyCreateUpdate,
		key: 'patient_allergy',
		label: 'Patient allergy',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	}
];

export const PatientAllergyReviewCreateUpdate: TaskTypeFields<PatientAllergyReviewCreateUpdateSerializer> = [
	{
		key: 'review',
		label: 'Review',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'PatientAllergyAction',
		fields: PatientAllergyAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: false,
		type: 'field_set',
	},
	{
		key: 'no_known_allergies',
		label: 'No known allergies',
		required: false,
		type: 'boolean',
	}
];

export const HistoryOfPresentIllness: TaskTypeFields<HistoryOfPresentIllnessSerializer> = [
	{
		key: 'chief_complaint',
		label: 'Chief complaint',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'symptoms',
		label: 'Symptoms',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'relevant_past_medical_history',
		label: 'Relevant past medical history',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'FULL_CARE',
				label: 'Full Care (Skilled)',
			},
			{
				key: 'CUSTODIAL_CARE',
				label: 'Custodial Care',
			},
			{
				key: 'PALLIATIVE_CARE',
				label: 'Palliative care',
			},
			{
				key: 'HOSPICE',
				label: 'Hospice',
			}
		],
		key: 'goals_of_care',
		label: 'Goals of care',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'old_records_acf_review_summary',
		label: 'Old records acf review summary',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const SocialHistory: TaskTypeFields<SocialHistorySerializer> = [
	{
		key: 'administrative_gender',
		label: 'Administrative gender',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'race',
		label: 'Race',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'marital_status',
		label: 'Marital status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'current_living_situation',
		label: 'Current living situation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'primary_caregiver',
		label: 'Primary caregiver',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'others_in_support_group',
		label: 'Others in support group',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'educational_level_health_literacy',
		label: 'Educational level health literacy',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'language',
		label: 'Language',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hobbies',
		label: 'Hobbies',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'activity_exercise',
		label: 'Activity exercise',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'spirituality',
		label: 'Spirituality',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'occupation_employment_history',
		label: 'Occupation employment history',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'financial_status',
		label: 'Financial status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'involved_services_community_agencies',
		label: 'Involved services community agencies',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'advanced_directives',
		label: 'Advanced directives',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'other',
		label: 'Other',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alcohol_use',
		label: 'Alcohol use',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'substance_abuse',
		label: 'Substance abuse',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'tobacco_use',
		label: 'Tobacco use',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pronouns',
		label: 'Pronouns',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'identity',
		label: 'Identity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'snomed_smoking_status',
		label: 'Snomed smoking status',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'snomed_smoking_status_date',
		label: 'Snomed smoking status date',
		required: false,
		type: 'date',
	},
	{
		key: 'snomed_sexual_orientation',
		label: 'Snomed sexual orientation',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'races',
		label: 'Races',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'ethnicities',
		label: 'Ethnicities',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'gender_identity',
		label: 'Gender identity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'birth_sex',
		label: 'Birth sex',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'financial_hardship',
		label: 'Financial hardship',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'stress',
		label: 'Stress',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const FamilyHistory: TaskTypeFields<FamilyHistorySerializer> = [
	{
		key: 'stroke',
		label: 'Stroke',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cad_mi',
		label: 'Cad mi',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dementia',
		label: 'Dementia',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'diabetes',
		label: 'Diabetes',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'parkinson_disease',
		label: 'Parkinson disease',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alzheimer_disease',
		label: 'Alzheimer disease',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cholesterol',
		label: 'Cholesterol',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'depression',
		label: 'Depression',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alcohol_dependence',
		label: 'Alcohol dependence',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychiatric_illness',
		label: 'Psychiatric illness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cancers',
		label: 'Cancers',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'abuse',
		label: 'Abuse',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'other',
		label: 'Other',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'stroke_relative',
		label: 'Stroke relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'cad_mi_relative',
		label: 'Cad mi relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'dementia_relative',
		label: 'Dementia relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'diabetes_relative',
		label: 'Diabetes relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'parkinson_disease_relative',
		label: 'Parkinson disease relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'alzheimer_disease_relative',
		label: 'Alzheimer disease relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'cholesterol_relative',
		label: 'Cholesterol relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'depression_relative',
		label: 'Depression relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'alcohol_dependence_relative',
		label: 'Alcohol dependence relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'psychiatric_illness_relative',
		label: 'Psychiatric illness relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'cancers_relative',
		label: 'Cancers relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'abuse_relative',
		label: 'Abuse relative',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'alzheimer_disease_note',
		label: 'Alzheimer disease note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cad_mi_note',
		label: 'Cad mi note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cancers_note',
		label: 'Cancers note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cholesterol_note',
		label: 'Cholesterol note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'diabetes_note',
		label: 'Diabetes note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'parkinson_disease_note',
		label: 'Parkinson disease note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'stroke_note',
		label: 'Stroke note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dementia_note',
		label: 'Dementia note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'depression_note',
		label: 'Depression note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alcohol_dependence_note',
		label: 'Alcohol dependence note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychiatric_illness_note',
		label: 'Psychiatric illness note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'abuse_note',
		label: 'Abuse note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const ImagingResultCreateUpdate: TaskTypeFields<ImagingResultCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: false,
		type: 'number',
	},
	{
		choices: [
			{
				key: 'aborted',
				label: 'aborted',
			},
			{
				key: 'active',
				label: 'active',
			},
			{
				key: 'cancelled',
				label: 'cancelled',
			},
			{
				key: 'completed',
				label: 'completed',
			},
			{
				key: 'held',
				label: 'held',
			},
			{
				key: 'new',
				label: 'new',
			},
			{
				key: 'normal',
				label: 'normal',
			},
			{
				key: 'nullified',
				label: 'nullified',
			},
			{
				key: 'obsolete',
				label: 'obsolete',
			},
			{
				key: 'suspended',
				label: 'suspended',
			}
		],
		key: 'status',
		label: 'Status',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'code',
		label: 'Code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'date',
	},
	{
		key: 'value_code',
		label: 'Value code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_string',
		label: 'Value string',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_quantity',
		label: 'Value quantity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'unit',
		label: 'Unit',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'order',
		label: 'Order',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'sub_category',
		label: 'Sub category',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'examination_date',
		label: 'Examination date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'reported_date',
		label: 'Reported date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'imaging_order_id',
		label: 'Imaging order id',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'reporting_clinic',
		label: 'Reporting clinic',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'interpretation',
		label: 'Interpretation',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const ImagingResultAction: TaskTypeFields<ImagingResultActionSerializer> = [
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		_class: 'ImagingResultCreateUpdate',
		fields: ImagingResultCreateUpdate,
		key: 'imaging_result',
		label: 'Imaging result',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	}
];

export const ImagingResultReviewCreateUpdate: TaskTypeFields<ImagingResultReviewCreateUpdateSerializer> = [
	{
		key: 'review',
		label: 'Review',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'ImagingResultAction',
		fields: ImagingResultAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: false,
		type: 'field_set',
	}
];

export const ClinicalTestResultCreateUpdate: TaskTypeFields<ClinicalTestResultCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: false,
		type: 'number',
	},
	{
		choices: [
			{
				key: 'aborted',
				label: 'aborted',
			},
			{
				key: 'active',
				label: 'active',
			},
			{
				key: 'cancelled',
				label: 'cancelled',
			},
			{
				key: 'completed',
				label: 'completed',
			},
			{
				key: 'held',
				label: 'held',
			},
			{
				key: 'new',
				label: 'new',
			},
			{
				key: 'normal',
				label: 'normal',
			},
			{
				key: 'nullified',
				label: 'nullified',
			},
			{
				key: 'obsolete',
				label: 'obsolete',
			},
			{
				key: 'suspended',
				label: 'suspended',
			}
		],
		key: 'status',
		label: 'Status',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'code',
		label: 'Code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'date',
	},
	{
		key: 'value_code',
		label: 'Value code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_string',
		label: 'Value string',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_quantity',
		label: 'Value quantity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'unit',
		label: 'Unit',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'order',
		label: 'Order',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const ClinicalTestResultAction: TaskTypeFields<ClinicalTestResultActionSerializer> = [
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		_class: 'ClinicalTestResultCreateUpdate',
		fields: ClinicalTestResultCreateUpdate,
		key: 'clinical_test_result',
		label: 'Clinical test result',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	}
];

export const ClinicalTestResultReviewCreateUpdate: TaskTypeFields<ClinicalTestResultReviewCreateUpdateSerializer> = [
	{
		key: 'review',
		label: 'Review',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'ClinicalTestResultAction',
		fields: ClinicalTestResultAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: false,
		type: 'field_set',
	}
];

export const ConstitutionalSystemReview: TaskTypeFields<ConstitutionalSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'awareness',
		label: 'Awareness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'weight_change',
		label: 'Weight change',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'fever',
		label: 'Fever',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		deprecated: true,
		key: 'chills',
		label: 'Chills',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'fatigue',
		label: 'Fatigue',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'malaise',
		label: 'Malaise',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const ENTOrMouthSystemReview: TaskTypeFields<ENTOrMouthSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'hearing_changes',
		label: 'Hearing changes',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'ear_pain',
		label: 'Ear pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'nasal_congestion',
		label: 'Nasal congestion',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sinus_pain',
		label: 'Sinus pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sore_throat',
		label: 'Sore throat',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'swallowing_difficulty',
		label: 'Swallowing difficulty',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const EyesSystemReview: TaskTypeFields<EyesSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'eye_pain',
		label: 'Eye pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'swelling',
		label: 'Swelling',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'redness',
		label: 'Redness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'foreign_body',
		label: 'Foreign body',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'discharge',
		label: 'Discharge',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'vision_changes',
		label: 'Vision changes',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const CardiovascularSystemReview: TaskTypeFields<CardiovascularSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'chest_pain',
		label: 'Chest pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sob',
		label: 'Sob',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pnd',
		label: 'Pnd',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'claudication',
		label: 'Claudication',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'edema',
		label: 'Edema',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'palpitations',
		label: 'Palpitations',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const RespiratorySystemReview: TaskTypeFields<RespiratorySystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'cough',
		label: 'Cough',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'wheezing',
		label: 'Wheezing',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dyspnea',
		label: 'Dyspnea',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pleurisy',
		label: 'Pleurisy',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const GastrointestinalSystemReview: TaskTypeFields<GastrointestinalSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'nausea',
		label: 'Nausea',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'vomiting',
		label: 'Vomiting',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'difficulty_with_bowels',
		label: 'Difficulty with bowels',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pain',
		label: 'Pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'heartburn',
		label: 'Heartburn',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dysphagia',
		label: 'Dysphagia',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const GenitourinarySystemReview: TaskTypeFields<GenitourinarySystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'dysuria',
		label: 'Dysuria',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'urinary_frequency',
		label: 'Urinary frequency',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'difficulty_with_urination',
		label: 'Difficulty with urination',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hematuria',
		label: 'Hematuria',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'flank_pain',
		label: 'Flank pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const MusculoskeletalSystemReview: TaskTypeFields<MusculoskeletalSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'diffuse_pain',
		label: 'Diffuse pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'joint_pain',
		label: 'Joint pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'muscle_pain',
		label: 'Muscle pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'neck_or_back_pain',
		label: 'Neck or back pain',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'joint_swelling',
		label: 'Joint swelling',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'joint_stiffness',
		label: 'Joint stiffness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'injury_history',
		label: 'Injury history',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const SkinSystemReview: TaskTypeFields<SkinSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'skin_lesions',
		label: 'Skin lesions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pruritus',
		label: 'Pruritus',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'rash',
		label: 'Rash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'skin_changes',
		label: 'Skin changes',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const NeuroSystemReview: TaskTypeFields<NeuroSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'weakness',
		label: 'Weakness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'numbness',
		label: 'Numbness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'loss_of_consciousness',
		label: 'Loss of consciousness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dizziness',
		label: 'Dizziness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'difficulty_with_speech',
		label: 'Difficulty with speech',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'difficulty_with_memory',
		label: 'Difficulty with memory',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const PsychSystemReview: TaskTypeFields<PsychSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'anxiety_or_panic',
		label: 'Anxiety or panic',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'depression',
		label: 'Depression',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'insomnia',
		label: 'Insomnia',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'delusions',
		label: 'Delusions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'violence_or_abuse_hx',
		label: 'Violence or abuse hx',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'eating_concerns',
		label: 'Eating concerns',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const HemORLymphSystemReview: TaskTypeFields<HemORLymphSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'bruising',
		label: 'Bruising',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'bleeding',
		label: 'Bleeding',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lymphadenopathy',
		label: 'Lymphadenopathy',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const EndocrineSystemReview: TaskTypeFields<EndocrineSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'polyuria',
		label: 'Polyuria',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'polydipsia',
		label: 'Polydipsia',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'temperature_intolerance',
		label: 'Temperature intolerance',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const ReviewOfSystems: TaskTypeFields<ReviewOfSystemsSerializer> = [
	{
		_class: 'ConstitutionalSystemReview',
		fields: ConstitutionalSystemReview,
		key: 'constitutional',
		label: 'Constitutional',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'ENTOrMouthSystemReview',
		fields: ENTOrMouthSystemReview,
		key: 'ent_or_mouth',
		label: 'ENT / Mouth',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'EyesSystemReview',
		fields: EyesSystemReview,
		key: 'eyes',
		label: 'Eyes',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'CardiovascularSystemReview',
		fields: CardiovascularSystemReview,
		key: 'cardiovascular',
		label: 'Cardiovascular',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RespiratorySystemReview',
		fields: RespiratorySystemReview,
		key: 'respiratory',
		label: 'Respiratory',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'GastrointestinalSystemReview',
		fields: GastrointestinalSystemReview,
		key: 'gastrointestinal',
		label: 'Gastrointestinal',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'GenitourinarySystemReview',
		fields: GenitourinarySystemReview,
		key: 'genitourinary',
		label: 'Genitourinary',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'MusculoskeletalSystemReview',
		fields: MusculoskeletalSystemReview,
		key: 'musculoskeletal',
		label: 'Musculoskeletal',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'SkinSystemReview',
		fields: SkinSystemReview,
		key: 'skin',
		label: 'Skin',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'NeuroSystemReview',
		fields: NeuroSystemReview,
		key: 'neuro',
		label: 'Neuro',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'PsychSystemReview',
		fields: PsychSystemReview,
		key: 'psych',
		label: 'Psych',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'HemORLymphSystemReview',
		fields: HemORLymphSystemReview,
		key: 'hem_lymph',
		label: 'Hem lymph',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'EndocrineSystemReview',
		fields: EndocrineSystemReview,
		key: 'endocrine',
		label: 'Endocrine',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'limited',
		label: 'Limited',
		required: false,
		type: 'boolean',
	},
	{
		key: 'limited_due_to',
		label: 'Limited due to',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const GeneralExam: TaskTypeFields<GeneralExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'alertness',
		label: 'Alertness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'nourishment',
		label: 'Nourishment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'acute_distress',
		label: 'Acute distress',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'normocephalic_atraumatic',
		label: 'Normocephalic atraumatic',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const SkinExam: TaskTypeFields<SkinExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'integrity',
		label: 'Integrity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'warm',
		label: 'Warm',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'color',
		label: 'Color',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'rashes',
		label: 'Rashes',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'indurations',
		label: 'Indurations',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'wounds_reported',
		label: 'Wounds reported',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const EyesExam: TaskTypeFields<EyesExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sclera_lids',
		label: 'Sclera lids',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'extra_ocular_movements',
		label: 'Extra ocular movements',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pupil',
		label: 'Pupil',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'eye_glasses',
		label: 'Eye glasses',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const ENTExam: TaskTypeFields<ENTExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'deformity',
		label: 'Deformity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'external_auditory_canal',
		label: 'External auditory canal',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'tympanic_membrane',
		label: 'Tympanic membrane',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'assistive_devices',
		label: 'Assistive devices',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const NeckExam: TaskTypeFields<NeckExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'mobility',
		label: 'Mobility',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'trachea',
		label: 'Trachea',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'thyroid_mass_tenderness',
		label: 'Thyroid mass tenderness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lymphadenopathy',
		label: 'Lymphadenopathy',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'jvd',
		label: 'Jvd',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const LungsExam: TaskTypeFields<LungsExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'auscultation',
		label: 'Auscultation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'accessory_muscle_use',
		label: 'Accessory muscle use',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'supplemental_oxygen_required',
		label: 'Supplemental oxygen required',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const HeartExam: TaskTypeFields<HeartExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'rate_rhythm',
		label: 'Rate rhythm',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'murmur',
		label: 'Murmur',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lower_extremity_edema',
		label: 'Lower extremity edema',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pedal_pulses',
		label: 'Pedal pulses',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'supplemental_oxygen_required',
		label: 'Supplemental oxygen required',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const AbdomenExam: TaskTypeFields<AbdomenExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'bowel_sounds',
		label: 'Bowel sounds',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'tenderness',
		label: 'Tenderness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'colostomy',
		label: 'Colostomy',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'medical_equipment',
		label: 'Medical equipment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const GUExam: TaskTypeFields<GUExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'bladder',
		label: 'Bladder',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cva',
		label: 'Cva',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'incontinence_assistance',
		label: 'Incontinence assistance',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const MuscularExam: TaskTypeFields<MuscularExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'cyanosis',
		label: 'Cyanosis',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'clubbing',
		label: 'Clubbing',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'edema',
		label: 'Edema',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'strength_and_movement',
		label: 'Strength and movement',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'tone_mass',
		label: 'Tone mass',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'muscle_mass',
		label: 'Muscle mass',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dme',
		label: 'Dme',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const NeuroExam: TaskTypeFields<NeuroExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'alertness',
		label: 'Alertness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'speech',
		label: 'Speech',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'memory',
		label: 'Memory',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hemiparesis',
		label: 'Hemiparesis',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'focal_deficits',
		label: 'Focal deficits',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const PsychExam: TaskTypeFields<PsychExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'orientedness',
		label: 'Orientedness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'affect',
		label: 'Affect',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'mood',
		label: 'Mood',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'resistive',
		label: 'Resistive',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const StatusObservationCreateUpdate: TaskTypeFields<StatusObservationCreateUpdateSerializer> = [
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'snomed_concept',
		label: 'Snomed concept',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'observation_date',
		label: 'Observation date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'mental_status_exam',
		label: 'Mental status exam',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'physical_examination',
		label: 'Physical examination',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		choices: [
			{
				key: 'STATUS_OBSERVATION_FUNCTIONAL',
				label: 'Functional',
			},
			{
				key: 'STATUS_OBSERVATION_COGNITIVE',
				label: 'Cognitive',
			}
		],
		key: 'type',
		label: 'Type',
		multiple: false,
		required: false,
		type: 'select',
	}
];

export const PhysicalExaminationCreateUpdate: TaskTypeFields<PhysicalExaminationCreateUpdateSerializer> = [
	{
		_class: 'GeneralExam',
		fields: GeneralExam,
		key: 'general_exam',
		label: 'General',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'SkinExam',
		fields: SkinExam,
		key: 'skin_exam',
		label: 'Skin',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'EyesExam',
		fields: EyesExam,
		key: 'eyes_exam',
		label: 'Eyes',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'ENTExam',
		fields: ENTExam,
		key: 'ent_exam',
		label: 'ENT',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'NeckExam',
		fields: NeckExam,
		key: 'neck_exam',
		label: 'Neck',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'LungsExam',
		fields: LungsExam,
		key: 'lungs_exam',
		label: 'Lungs',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'HeartExam',
		fields: HeartExam,
		key: 'heart_exam',
		label: 'Heart',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'AbdomenExam',
		fields: AbdomenExam,
		key: 'abdomen_exam',
		label: 'Abdomen',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'GUExam',
		fields: GUExam,
		key: 'gu_exam',
		label: 'GU',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'MuscularExam',
		fields: MuscularExam,
		key: 'muscular_exam',
		label: 'Muscular',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'NeuroExam',
		fields: NeuroExam,
		key: 'neuro_exam',
		label: 'Neuro',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'PsychExam',
		fields: PsychExam,
		key: 'psych_exam',
		label: 'Psych',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'limited',
		label: 'Limited',
		required: false,
		type: 'boolean',
	},
	{
		key: 'limited_due_to',
		label: 'Limited due to',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'StatusObservationCreateUpdate',
		fields: StatusObservationCreateUpdate,
		key: 'status_observations',
		label: 'Status Observation',
		multiple: true,
		required: false,
		type: 'field_set',
	}
];

export const ImmunizationCreateUpdate: TaskTypeFields<ImmunizationCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'date',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'name',
		label: 'Name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'step',
		label: 'Step',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'code',
		label: 'Code',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'site',
		label: 'Site',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'expiration',
		label: 'Expiration',
		required: false,
		type: 'date',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'status',
		label: 'Status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'status_reason',
		label: 'Status reason',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'type',
		label: 'Type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'result',
		label: 'Result',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'consent_status',
		label: 'Consent status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'is_covid_related',
		label: 'Is covid related',
		required: false,
		type: 'boolean',
	},
	{
		choices: [
			{
				key: 'VACCINE',
				label: 'Vaccine',
			},
			{
				key: 'TEST',
				label: 'Test',
			}
		],
		key: 'procedure_type',
		label: 'Procedure type',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'copied_from',
		label: 'Copied from',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'staff_name',
		label: 'Staff name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lot_number',
		label: 'Lot number',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	}
];

export const ImmunizationAction: TaskTypeFields<ImmunizationActionSerializer> = [
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		_class: 'ImmunizationCreateUpdate',
		fields: ImmunizationCreateUpdate,
		key: 'immunization',
		label: 'Immunization',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	}
];

export const ImmunizationReviewCreateUpdate: TaskTypeFields<ImmunizationReviewCreateUpdateSerializer> = [
	{
		key: 'review',
		label: 'Review',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'ImmunizationAction',
		fields: ImmunizationAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: false,
		type: 'field_set',
	}
];

export const ProcedureRelatedDeviceCreateUpdate: TaskTypeFields<ProcedureRelatedDeviceCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: false,
		type: 'number',
	},
	{
		key: 'device',
		label: 'Device',
		multiple: false,
		required: true,
		type: 'foreign_key_select',
	},
	{
		choices: [
			{
				key: 'implanted',
				label: 'Implanted',
			},
			{
				key: 'explanted',
				label: 'Explanted',
			},
			{
				key: 'manipulated',
				label: 'Manipulated',
			}
		],
		key: 'device_action',
		label: 'Device action',
		multiple: false,
		required: true,
		type: 'select',
	}
];

export const ProcedureCreateUpdate: TaskTypeFields<ProcedureCreateUpdateSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: false,
		type: 'number',
	},
	{
		key: 'code',
		label: 'Code',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: true,
		type: 'foreign_key_select',
	},
	{
		key: 'status',
		label: 'Status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'ProcedureRelatedDeviceCreateUpdate',
		fields: ProcedureRelatedDeviceCreateUpdate,
		key: 'procedure_related_devices',
		label: 'Procedure related devices',
		multiple: true,
		required: false,
		type: 'field_set',
	},
	{
		key: 'performed',
		label: 'Performed',
		required: false,
		type: 'datetime',
	},
	{
		key: 'target_sites',
		label: 'Target sites',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'related_icd_diagnosis',
		label: 'Related icd diagnosis',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const ProcedureAction: TaskTypeFields<ProcedureActionSerializer> = [
	{
		_class: 'ProcedureCreateUpdate',
		fields: ProcedureCreateUpdate,
		key: 'procedure',
		label: 'Procedure',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	}
];

export const ProcedureReview: TaskTypeFields<ProcedureReviewSerializer> = [
	{
		_class: 'ProcedureAction',
		fields: ProcedureAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: false,
		type: 'field_set',
	},
	{
		key: 'review',
		label: 'Review',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const GoalTargetCreateUpdate: TaskTypeFields<GoalTargetCreateUpdateSerializer> = [
	{
		key: 'measure_text',
		label: 'Measure text',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'measure_decimal',
		label: 'Measure decimal',
		required: false,
	},
	{
		key: 'measure_range',
		label: 'Measure range',
		required: false,
	},
	{
		key: 'measure_snomed',
		label: 'Measure snomed',
		required: false,
		type: 'number',
	},
	{
		key: 'detail',
		label: 'Detail',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'due_date',
		label: 'Due date',
		required: false,
		type: 'date',
	}
];

export const GoalCreateUpdate: TaskTypeFields<GoalCreateUpdateSerializer> = [
	{
		choices: [
			{
				key: 'LIFECYCLE_STATUS_NONE',
				label: '',
			},
			{
				key: 'LIFECYCLE_STATUS_PROPOSED',
				label: 'Proposed',
			},
			{
				key: 'LIFECYCLE_STATUS_PLANNED',
				label: 'Planned',
			},
			{
				key: 'LIFECYCLE_STATUS_ACCEPTED',
				label: 'Accepted',
			},
			{
				key: 'LIFECYCLE_STATUS_ACTIVVE',
				label: 'Active',
			},
			{
				key: 'LIFECYCLE_STATUS_ON_HOLD',
				label: 'On Hold',
			},
			{
				key: 'LIFECYCLE_STATUS_COMPLETED',
				label: 'Completed',
			},
			{
				key: 'LIFECYCLE_STATUS_CANCELLED',
				label: 'Cancelled',
			},
			{
				key: 'LIFECYCLE_STATUS_ENTERED_IN_ERROR',
				label: 'Entered in Error',
			},
			{
				key: 'LIFECYCLE_STATUS_REJECTED',
				label: 'Rejected',
			}
		],
		key: 'lifecycle_status',
		label: 'Lifecycle status',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'ACHIEVEMENT_STATUS_NONE',
				label: '',
			},
			{
				key: 'ACHIEVEMENT_STATUS_PROPOSED',
				label: 'Proposed',
			},
			{
				key: 'ACHIEVEMENT_STATUS_IMPROVING',
				label: 'Improving',
			},
			{
				key: 'ACHIEVEMENT_STATUS_WORSENING',
				label: 'Worsening',
			},
			{
				key: 'ACHIEVEMENT_STATUS_NO_CHANGE',
				label: 'No Change',
			},
			{
				key: 'ACHIEVEMENT_STATUS_ACHIEVED',
				label: 'Achieved',
			},
			{
				key: 'ACHIEVEMENT_STATUS_SUSTAINING',
				label: 'Sustaining',
			},
			{
				key: 'ACHIEVEMENT_STATUS_NOT_ACHIEVED',
				label: 'Not Achieved',
			},
			{
				key: 'ACHIEVEMENT_STATUS_NO_PROGRESS',
				label: 'No Progress',
			},
			{
				key: 'ACHIEVEMENT_STATUS_NOT_ATTAINABLE',
				label: 'Not Attainable',
			}
		],
		key: 'achievement_status',
		label: 'Achievement status',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'goal_category',
		label: 'Goal category',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'continuous',
		label: 'Continuous',
		required: false,
		type: 'boolean',
	},
	{
		choices: [
			{
				key: 'GOAL_PRIORITY_NONE',
				label: '',
			},
			{
				key: 'GOAL_PRIORITY_HIGH_PRIORITY',
				label: 'High Priority',
			},
			{
				key: 'GOAL_PRIORITY_MEDIUM_PRIORITY',
				label: 'Medium Priority',
			},
			{
				key: 'GOAL_PRIORITY_LOW_PRIORITY',
				label: 'Low Priority',
			}
		],
		key: 'goal_priority',
		label: 'Goal priority',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'description_text',
		label: 'Description text',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'description_code',
		label: 'Description code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'subject_patient',
		label: 'Subject patient',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'start_date',
		label: 'Start date',
		required: false,
		type: 'date',
	},
	{
		key: 'status_date',
		label: 'Status date',
		required: false,
		type: 'date',
	},
	{
		key: 'status_reason',
		label: 'Status reason',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'source_user',
		label: 'Source user',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		_class: 'GoalTargetCreateUpdate',
		fields: GoalTargetCreateUpdate,
		key: 'goal_targets',
		label: 'Goal targets',
		multiple: true,
		required: true,
		type: 'field_set',
	}
];

export const WoundNestedCreate: TaskTypeFields<WoundNestedCreateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'target_site_qualifiers',
		label: 'Target site qualifiers',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'created_at',
		label: 'Created at',
		required: false,
		type: 'datetime',
	},
	{
		key: 'modified_at',
		label: 'Modified at',
		required: false,
		type: 'datetime',
	},
	{
		key: 'wound_identifier',
		label: 'Wound identifier',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'date_unknown',
		label: 'Date unknown',
		required: false,
		type: 'boolean',
	},
	{
		choices: [
			{
				key: 'PRESENT_ON_ADMISSION',
				label: 'Present on Admission',
			},
			{
				key: 'ACQUIRED_IN_HOUSE',
				label: 'Acquired In-House',
			}
		],
		key: 'present_on_admission',
		label: 'Present on admission',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'date_of_referral',
		label: 'Date of referral',
		required: false,
		type: 'date',
	},
	{
		key: 'above_knee',
		label: 'Above knee',
		required: false,
		type: 'boolean',
	},
	{
		key: 'location',
		label: 'Location',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'position_associated_wound',
		label: 'Position associated wound',
		required: false,
		type: 'boolean',
	},
	{
		choices: [
			{
				key: 'PRESSURE_ULCER',
				label: 'Pressure Ulcer',
			},
			{
				key: 'ARTERIAL_ULCER',
				label: 'Arterial Ulcer',
			},
			{
				key: 'DIABETIC_ULCER',
				label: 'Diabetic Ulcer',
			},
			{
				key: 'VENOUS_STASIS_ULCER',
				label: 'Venous Stasis Ulcer',
			},
			{
				key: 'SURGICAL_WOUND',
				label: 'Surgical Wound',
			},
			{
				key: 'LACERATION',
				label: 'Laceration',
			},
			{
				key: 'BRUISE',
				label: 'Bruise',
			},
			{
				key: 'SKIN_TEAR',
				label: 'Skin Tear',
			},
			{
				key: 'ABRASION',
				label: 'Abrasion',
			},
			{
				key: 'OTHER',
				label: 'Other',
			}
		],
		key: 'wound_type',
		label: 'Wound type',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: true,
		type: 'foreign_key_select',
	},
	{
		key: 'wound_location',
		label: 'Wound location',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const NegationReason: TaskTypeFields<NegationReasonSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'section',
		label: 'Section',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'subject',
		label: 'Subject',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'reason',
		label: 'Reason',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const PlanAction: TaskTypeFields<PlanActionSerializer> = [
	{
		choices: [
			{
				key: 'ADD',
				label: 'Add to Problem List',
			},
			{
				key: 'ACTIVE',
				label: 'Active',
			},
			{
				key: 'ACUTE',
				label: 'Acute',
			},
			{
				key: 'RESOLVED',
				label: 'Resolved',
			},
			{
				key: 'DORMANT',
				label: 'Dormant',
			},
			{
				key: 'INSUFFICIENT',
				label: 'Insufficient',
			},
			{
				key: 'NO_ACTION',
				label: 'No Action',
			},
			{
				key: 'REVIEW',
				label: 'Review',
			},
			{
				key: 'COMMENT',
				label: 'Care Plan',
			},
			{
				key: 'UPDATE',
				label: 'Update',
			},
			{
				key: 'UPDATE_ICD',
				label: 'Update ICD-10',
			},
			{
				key: 'DISCONTINUE',
				label: 'Discontinue',
			},
			{
				key: 'LAB_ORDER',
				label: 'Lab Order',
			},
			{
				key: 'RX_ORDER',
				label: 'Rx Order',
			},
			{
				key: 'OTHER_ORDER',
				label: 'Other Order',
			},
			{
				key: 'GOAL',
				label: 'Goal',
			},
			{
				key: 'HEALTH_CONCERN',
				label: 'Health Concern',
			},
			{
				key: 'PROCEDURE_ORDER',
				label: 'Procedure Order',
			},
			{
				key: 'NEGATION_REASON',
				label: 'Negation Reason',
			},
			{
				key: 'WOUND_REVIEW',
				label: 'Wound review',
			},
			{
				key: 'DRESSING_ORDER',
				label: 'Dressing order',
			}
		],
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'select',
	},
	{
		_class: 'GoalCreateUpdate',
		fields: GoalCreateUpdate,
		key: 'goal',
		label: 'Goal',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'DiagnosisCreateUpdate',
		fields: DiagnosisCreateUpdate,
		key: 'diagnosis',
		label: 'Diagnosis',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hash',
		label: 'Hash',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hidden_in_plan',
		label: 'Hidden in plan',
		required: false,
		type: 'boolean',
	},
	{
		key: 'sort',
		label: 'Sort',
		required: false,
		type: 'number',
	},
	{
		key: 'assessment_plan',
		label: 'Assessment plan',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		_class: 'EventCreateUpdate',
		fields: EventCreateUpdate,
		key: 'event',
		label: 'Event',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'vital',
		label: 'Vital',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		_class: 'TreatmentHistoryCreate',
		fields: TreatmentHistoryCreate,
		key: 'treatment_history',
		label: 'Treatment history',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'LabTestCreateUpdate',
		fields: LabTestCreateUpdate,
		key: 'lab_test',
		label: 'Lab test',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'icd',
		label: 'Icd',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'icd_update',
		label: 'Icd update',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		_class: 'ProcedureCreateUpdate',
		fields: ProcedureCreateUpdate,
		key: 'procedure',
		label: 'Procedure',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'PatientAllergyCreateUpdate',
		fields: PatientAllergyCreateUpdate,
		key: 'patient_allergy',
		label: 'Patient allergy',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'ImmunizationCreateUpdate',
		fields: ImmunizationCreateUpdate,
		key: 'immunization',
		label: 'Immunization',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'ClinicalTestResultCreateUpdate',
		fields: ClinicalTestResultCreateUpdate,
		key: 'clinical_test_result',
		label: 'Clinical test result',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'WoundNestedCreate',
		fields: WoundNestedCreate,
		key: 'wound',
		label: 'Wound',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'ImagingResultCreateUpdate',
		fields: ImagingResultCreateUpdate,
		key: 'imaging_result',
		label: 'Imaging result',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'NegationReason',
		fields: NegationReason,
		key: 'negation_reason',
		label: 'Negation reason',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'IN_EXACERBATION',
				label: 'In exacerbation',
			},
			{
				key: 'ACTIVELY_MONITORING',
				label: 'Actively monitoring',
			},
			{
				key: 'WORSENING',
				label: 'Worsening',
			},
			{
				key: 'CHRONIC_MANAGED',
				label: 'Chronic, managed',
			},
			{
				key: 'ACTIVE',
				label: 'Active',
			},
			{
				key: 'RESOLVED',
				label: 'Resolved',
			}
		],
		key: 'disease_status',
		label: 'Disease status',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	}
];

export const AssessmentPlan: TaskTypeFields<AssessmentPlanSerializer> = [
	{
		key: 'assessment',
		label: 'Assessment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'plan',
		label: 'Plan',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'GENERAL',
				label: 'General',
			},
			{
				key: 'EYES',
				label: 'Eyes',
			},
			{
				key: 'EARS_NOSE_MOUTH_THROAT',
				label: 'Ears / Nose / Mouth / Throat',
			},
			{
				key: 'RESPIRATORY',
				label: 'Respiratory',
			},
			{
				key: 'CARDIOVASCULAR',
				label: 'Cardiovascular',
			},
			{
				key: 'GASTROINTESTINAL',
				label: 'Gastrointestinal',
			},
			{
				key: 'GENITOURINARY',
				label: 'Genitourinary',
			},
			{
				key: 'MUSCULOSKELETAL',
				label: 'Musculoskeletal',
			},
			{
				key: 'NEUROLOGICAL',
				label: 'Neurological',
			},
			{
				key: 'SKIN_BREAST',
				label: 'Skin / Breast',
			},
			{
				key: 'PSYCHIATRIC',
				label: 'Psychiatric',
			},
			{
				key: 'ENDOCRINE',
				label: 'Endocrine',
			},
			{
				key: 'HEMATOLOGICAL_LYMPHATIC',
				label: 'Hematological / Lymphatic',
			},
			{
				key: 'ALLERGIC_IMMUNOLOGIC',
				label: 'Allergic / Immunologic',
			}
		],
		icon: 'diagnoses',
		key: 'systems',
		label: 'Systems',
		multiple: true,
		required: false,
		type: 'select',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		icon: 'stethoscope',
		key: 'related_icd_diagnoses',
		label: 'Related icd diagnoses',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	},
	{
		_class: 'PlanAction',
		fields: PlanAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: false,
		type: 'field_set',
	}
];

export const PatientComplexity: TaskTypeFields<PatientComplexitySerializer> = [
	{
		choices: [
			{
				key: 'PATIENT_MAKING_GAINS',
				label: 'Patient Making Gains',
			},
			{
				key: 'MANAGE_DECLINE',
				label: 'Manage Decline (minimal gains)',
			},
			{
				key: 'MONITOR_DECLINE',
				label: 'Monitor Decline (stable, no gains)',
			},
			{
				key: 'PATIENT_PROGNOSIS_POOR',
				label: 'Patient Prognosis is Poor',
			}
		],
		key: 'phase_of_decline',
		label: 'Phase of decline',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'MILD',
				label: 'Mild',
			},
			{
				key: 'MODERATE',
				label: 'Moderate',
			},
			{
				key: 'SIGNIFICANT',
				label: 'Significant',
			}
		],
		key: 'symptom_burden_intolerance',
		label: 'Symptom burden intolerance',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'PLAN_ESTABLISHED',
				label: 'Plan established',
			},
			{
				key: 'NOT_INTERESTED',
				label: 'Not interested',
			},
			{
				key: 'INTERESTED',
				label: 'Interested, please contact',
			}
		],
		key: 'advanced_care_plan',
		label: 'Advanced care plan',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'complexity_statement',
		label: 'Complexity statement',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'health_status',
		label: 'Health status',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'health_status_comments',
		label: 'Health status comments',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const VisitDetails: TaskTypeFields<VisitDetailsSerializer> = [
	{
		key: 'billing_code',
		label: 'Billing code',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'addon_code',
		label: 'Addon code',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'NEXT_SCHEDULED',
				label: 'Next appointment on schedule',
			},
			{
				key: 'NEXT_AVAILABLE',
				label: 'Next available',
			},
			{
				key: 'NEXT_REGULAR',
				label: 'Next regular',
			},
			{
				key: '1_WEEK',
				label: '1 week',
			},
			{
				key: '2_WEEKS',
				label: '2 weeks',
			},
			{
				key: '3_WEEKS',
				label: '3 weeks',
			},
			{
				key: '30_DAYS',
				label: '30 days',
			},
			{
				key: 'NO_VISIT_DISCHARGE',
				label: 'No visit, discharge pending',
			}
		],
		key: 'next_appointment_in',
		label: 'Next appointment in',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'PHYSICIAN',
				label: 'Physician',
			},
			{
				key: 'ADVANCED_PRACTICE_PROVIDER',
				label: 'Advanced Practice Provider',
			},
			{
				key: 'EITHER',
				label: 'Either',
			}
		],
		key: 'next_appointment_with',
		label: 'Next appointment with',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'next_appointment_date',
		label: 'Next appointment date',
		required: false,
		type: 'date',
	},
	{
		key: 'comments',
		label: 'Comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'visit_comments',
		label: 'Visit comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'reason_for_next_visit',
		label: 'Reason for next visit',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'next_appointment_type',
		label: 'Next appointment type',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'related_person',
		label: 'Related person',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'procedure',
		label: 'Procedure',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'visit',
		label: 'Visit',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const BehavioralPastPsychiatricHistory: TaskTypeFields<BehavioralPastPsychiatricHistorySerializer> = [
	{
		key: 'dc_meds',
		label: 'Dc meds',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'exposure_to_violence',
		label: 'Exposure to violence',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'exposure_to_violence_note',
		label: 'Exposure to violence note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hx_of_suicide_attempts',
		label: 'Hx of suicide attempts',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hx_of_suicide_attempts_note',
		label: 'Hx of suicide attempts note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hx_of_self_harm',
		label: 'Hx of self harm',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hx_of_self_harm_note',
		label: 'Hx of self harm note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hx_of_violence',
		label: 'Hx of violence',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hx_of_violence_note',
		label: 'Hx of violence note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'inpatient_treatment',
		label: 'Inpatient treatment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'inpatient_treatment_note',
		label: 'Inpatient treatment note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'outpatient_treatment',
		label: 'Outpatient treatment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'outpatient_treatment_note',
		label: 'Outpatient treatment note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychotherapy',
		label: 'Psychotherapy',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychotherapy_note',
		label: 'Psychotherapy note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralSocialHistory: TaskTypeFields<BehavioralSocialHistorySerializer> = [
	{
		key: 'administrative_gender',
		label: 'Administrative gender',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'race',
		label: 'Race',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'marital_status',
		label: 'Marital status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'current_living_situation',
		label: 'Current living situation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'primary_caregiver',
		label: 'Primary caregiver',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'others_in_support_group',
		label: 'Others in support group',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'educational_level_health_literacy',
		label: 'Educational level health literacy',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'language',
		label: 'Language',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'hobbies',
		label: 'Hobbies',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'activity_exercise',
		label: 'Activity exercise',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'spirituality',
		label: 'Spirituality',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'occupation_employment_history',
		label: 'Occupation employment history',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'financial_status',
		label: 'Financial status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'involved_services_community_agencies',
		label: 'Involved services community agencies',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'advanced_directives',
		label: 'Advanced directives',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'other',
		label: 'Other',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alcohol_use',
		label: 'Alcohol use',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'substance_abuse',
		label: 'Substance abuse',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'tobacco_use',
		label: 'Tobacco use',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'pronouns',
		label: 'Pronouns',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'identity',
		label: 'Identity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'marital_status_note',
		label: 'Marital status note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'current_living_situation_note',
		label: 'Current living situation note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'primary_caregiver_note',
		label: 'Primary caregiver note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'others_in_support_group_note',
		label: 'Others in support group note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'educational_level_health_literacy_note',
		label: 'Educational level health literacy note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'language_note',
		label: 'Language note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'relationship_with_peers',
		label: 'Relationship with peers',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'relationship_with_peers_note',
		label: 'Relationship with peers note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'financial_status_note',
		label: 'Financial status note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'involved_services_community_agencies_note',
		label: 'Involved services community agencies note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'advanced_directives_note',
		label: 'Advanced directives note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'legal_issues',
		label: 'Legal issues',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'legal_issues_note',
		label: 'Legal issues note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sexual_history',
		label: 'Sexual history',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sexual_history_note',
		label: 'Sexual history note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'administrative_gender_note',
		label: 'Administrative gender note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'snomed_smoking_status',
		label: 'Snomed smoking status',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'snomed_smoking_status_date',
		label: 'Snomed smoking status date',
		required: false,
		type: 'date',
	},
	{
		key: 'snomed_sexual_orientation',
		label: 'Snomed sexual orientation',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'races',
		label: 'Races',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'ethnicities',
		label: 'Ethnicities',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'gender_identity',
		label: 'Gender identity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'birth_sex',
		label: 'Birth sex',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralFamilyHistory: TaskTypeFields<BehavioralFamilyHistorySerializer> = [
	{
		key: 'stroke',
		label: 'Stroke',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cad_mi',
		label: 'Cad mi',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dementia',
		label: 'Dementia',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'diabetes',
		label: 'Diabetes',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'parkinson_disease',
		label: 'Parkinson disease',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alzheimer_disease',
		label: 'Alzheimer disease',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cholesterol',
		label: 'Cholesterol',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'depression',
		label: 'Depression',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alcohol_dependence',
		label: 'Alcohol dependence',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychiatric_illness',
		label: 'Psychiatric illness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cancers',
		label: 'Cancers',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'abuse',
		label: 'Abuse',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'other',
		label: 'Other',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dementia_note',
		label: 'Dementia note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'depression_note',
		label: 'Depression note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychiatric_illness_note',
		label: 'Psychiatric illness note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alcohol_dependence_note',
		label: 'Alcohol dependence note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'abuse_note',
		label: 'Abuse note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'other_note',
		label: 'Other note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralDevelopmentalHistory: TaskTypeFields<BehavioralDevelopmentalHistorySerializer> = [
	{
		key: 'childhood_experience',
		label: 'Childhood experience',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'childhood_experience_note',
		label: 'Childhood experience note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'childhood_issues',
		label: 'Childhood issues',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'childhood_issues_note',
		label: 'Childhood issues note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'childhood_parents',
		label: 'Childhood parents',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'childhood_parents_note',
		label: 'Childhood parents note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'family_included',
		label: 'Family included',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'family_included_note',
		label: 'Family included note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'relationship',
		label: 'Relationship',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'relationship_note',
		label: 'Relationship note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'relationship_with_family',
		label: 'Relationship with family',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'relationship_with_family_note',
		label: 'Relationship with family note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'summary',
		label: 'Summary',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralPsychosocialCircumstancesInfluencingHealthStatus: TaskTypeFields<BehavioralPsychosocialCircumstancesInfluencingHealthStatusSerializer> = [
	{
		key: 'education',
		label: 'Education',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'education_note',
		label: 'Education note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'employment',
		label: 'Employment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'employment_note',
		label: 'Employment note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'family',
		label: 'Family',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'family_note',
		label: 'Family note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'housing_and_economic',
		label: 'Housing and economic',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'housing_and_economic_note',
		label: 'Housing and economic note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychosocial',
		label: 'Psychosocial',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychosocial_note',
		label: 'Psychosocial note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'social',
		label: 'Social',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'social_note',
		label: 'Social note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'upbringing',
		label: 'Upbringing',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'upbringing_note',
		label: 'Upbringing note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralSymptomsOfIllness: TaskTypeFields<BehavioralSymptomsOfIllnessSerializer> = [
	{
		key: 'sleep_disruptions',
		label: 'Sleep disruptions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sleep_disruptions_note',
		label: 'Sleep disruptions note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'fatigue',
		label: 'Fatigue',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'fatigue_note',
		label: 'Fatigue note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'impaired_concentration',
		label: 'Impaired concentration',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'impaired_concentration_note',
		label: 'Impaired concentration note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'guilt',
		label: 'Guilt',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'guilt_note',
		label: 'Guilt note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lack_of_pleasure',
		label: 'Lack of pleasure',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lack_of_pleasure_note',
		label: 'Lack of pleasure note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'appetite',
		label: 'Appetite',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'appetite_note',
		label: 'Appetite note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychomotor',
		label: 'Psychomotor',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychomotor_note',
		label: 'Psychomotor note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'suicidal_ideation',
		label: 'Suicidal ideation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'suicidal_ideation_note',
		label: 'Suicidal ideation note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralBaselineEvaluation: TaskTypeFields<BehavioralBaselineEvaluationSerializer> = [
	{
		key: 'intelligence',
		label: 'Intelligence',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'intelligence_note',
		label: 'Intelligence note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cognition',
		label: 'Cognition',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cognition_note',
		label: 'Cognition note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'concentration',
		label: 'Concentration',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'concentration_note',
		label: 'Concentration note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'age',
		label: 'Age',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'age_note',
		label: 'Age note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'physique',
		label: 'Physique',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'physique_note',
		label: 'Physique note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'insight_and_judgement',
		label: 'Insight and judgement',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'insight_and_judgement_note',
		label: 'Insight and judgement note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'memory',
		label: 'Memory',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'memory_note',
		label: 'Memory note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralTraumaEvaluation: TaskTypeFields<BehavioralTraumaEvaluationSerializer> = [
	{
		key: 'acknowledgements',
		label: 'Acknowledgements',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'acknowledgements_note',
		label: 'Acknowledgements note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'trauma_assessment',
		label: 'Trauma assessment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'trauma_assessment_note',
		label: 'Trauma assessment note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'trauma_specified_as',
		label: 'Trauma specified as',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'trauma_specified_as_note',
		label: 'Trauma specified as note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'traumatic_stressful_events',
		label: 'Traumatic stressful events',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'traumatic_stressful_events_note',
		label: 'Traumatic stressful events note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralPatientAwarenessOfConsequencesOfIllnessAndBehaviorOn: TaskTypeFields<BehavioralPatientAwarenessOfConsequencesOfIllnessAndBehaviorOnSerializer> = [
	{
		key: 'current_living_situation',
		label: 'Current living situation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'current_living_situation_note',
		label: 'Current living situation note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'family',
		label: 'Family',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'family_note',
		label: 'Family note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'social',
		label: 'Social',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'social_note',
		label: 'Social note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'work_school_community',
		label: 'Work school community',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'work_school_community_note',
		label: 'Work school community note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralNeuroSystemReview: TaskTypeFields<BehavioralNeuroSystemReviewSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'weakness',
		label: 'Weakness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'numbness',
		label: 'Numbness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'loss_of_consciousness',
		label: 'Loss of consciousness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dizziness',
		label: 'Dizziness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralReviewOfSystems: TaskTypeFields<BehavioralReviewOfSystemsSerializer> = [
	{
		_class: 'ENTOrMouthSystemReview',
		fields: ENTOrMouthSystemReview,
		key: 'ent_or_mouth',
		label: 'ENT / Mouth',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'EyesSystemReview',
		fields: EyesSystemReview,
		key: 'eyes',
		label: 'Eyes',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'CardiovascularSystemReview',
		fields: CardiovascularSystemReview,
		key: 'cardiovascular',
		label: 'Cardiovascular',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RespiratorySystemReview',
		fields: RespiratorySystemReview,
		key: 'respiratory',
		label: 'Respiratory',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'GastrointestinalSystemReview',
		fields: GastrointestinalSystemReview,
		key: 'gastrointestinal',
		label: 'Gastrointestinal',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'GenitourinarySystemReview',
		fields: GenitourinarySystemReview,
		key: 'genitourinary',
		label: 'Genitourinary',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'MusculoskeletalSystemReview',
		fields: MusculoskeletalSystemReview,
		key: 'musculoskeletal',
		label: 'Musculoskeletal',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'SkinSystemReview',
		fields: SkinSystemReview,
		key: 'skin',
		label: 'Skin',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'BehavioralNeuroSystemReview',
		fields: BehavioralNeuroSystemReview,
		key: 'neuro',
		label: 'Neuro',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'HemORLymphSystemReview',
		fields: HemORLymphSystemReview,
		key: 'hem_lymph',
		label: 'Hem lymph',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'EndocrineSystemReview',
		fields: EndocrineSystemReview,
		key: 'endocrine',
		label: 'Endocrine',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'limited',
		label: 'Limited',
		required: false,
		type: 'boolean',
	},
	{
		key: 'limited_due_to',
		label: 'Limited due to',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralMentalStatusExamAdditionalAssessment: TaskTypeFields<BehavioralMentalStatusExamAdditionalAssessmentSerializer> = [
	{
		key: 'cognition',
		label: 'Cognition',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'concentration',
		label: 'Concentration',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'memory',
		label: 'Memory',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'decisiveness',
		label: 'Decisiveness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'worthiness',
		label: 'Worthiness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychomotor',
		label: 'Psychomotor',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralMentalStatusExamCognition: TaskTypeFields<BehavioralMentalStatusExamCognitionSerializer> = [
	{
		key: 'cognition',
		label: 'Cognition',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'association',
		label: 'Association',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'mood',
		label: 'Mood',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'affect',
		label: 'Affect',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralMentalStatusExamConditionsAndSymptoms: TaskTypeFields<BehavioralMentalStatusExamConditionsAndSymptomsSerializer> = [
	{
		key: 'sleep_disruptions',
		label: 'Sleep disruptions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'fatigue',
		label: 'Fatigue',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'suicidal',
		label: 'Suicidal',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'homicidal',
		label: 'Homicidal',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychosis',
		label: 'Psychosis',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'appetite_and_weight',
		label: 'Appetite and weight',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'insight_and_judgement',
		label: 'Insight and judgement',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralMentalStatusExamGeneral: TaskTypeFields<BehavioralMentalStatusExamGeneralSerializer> = [
	{
		key: 'awareness',
		label: 'Awareness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alertness',
		label: 'Alertness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'weight_change',
		label: 'Weight change',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'malaise',
		label: 'Malaise',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralMentalStatusExamObservation: TaskTypeFields<BehavioralMentalStatusExamObservationSerializer> = [
	{
		key: 'appearance',
		label: 'Appearance',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'behavior',
		label: 'Behavior',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'speech',
		label: 'Speech',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'eye_contact',
		label: 'Eye contact',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'motor_skills',
		label: 'Motor skills',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'involuntary_movement',
		label: 'Involuntary movement',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralMentalStatusExamCreateUpdate: TaskTypeFields<BehavioralMentalStatusExamCreateUpdateSerializer> = [
	{
		_class: 'BehavioralMentalStatusExamAdditionalAssessment',
		fields: BehavioralMentalStatusExamAdditionalAssessment,
		key: 'additional_assessment',
		label: 'Additional assessment',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'BehavioralMentalStatusExamCognition',
		fields: BehavioralMentalStatusExamCognition,
		key: 'cognition',
		label: 'Cognition',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'BehavioralMentalStatusExamConditionsAndSymptoms',
		fields: BehavioralMentalStatusExamConditionsAndSymptoms,
		key: 'conditions_and_symptoms',
		label: 'Conditions and symptoms',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'BehavioralMentalStatusExamGeneral',
		fields: BehavioralMentalStatusExamGeneral,
		key: 'general',
		label: 'General',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'limited',
		label: 'Limited',
		required: false,
		type: 'boolean',
	},
	{
		key: 'limited_due_to',
		label: 'Limited due to',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'BehavioralMentalStatusExamObservation',
		fields: BehavioralMentalStatusExamObservation,
		key: 'observation',
		label: 'Observation',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'StatusObservationCreateUpdate',
		fields: StatusObservationCreateUpdate,
		key: 'status_observations',
		label: 'Status Observation',
		multiple: true,
		required: false,
		type: 'field_set',
	}
];

export const BehavioralNeuroExam: TaskTypeFields<BehavioralNeuroExamSerializer> = [
	{
		key: 'global_value',
		label: 'Global value',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'no_problems',
		label: 'No problems',
		required: false,
		type: 'boolean',
	},
	{
		key: 'hemiparesis',
		label: 'Hemiparesis',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'focal_deficits',
		label: 'Focal deficits',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'comment',
		label: 'Comment',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const BehavioralPhysicalExaminationCreateUpdate: TaskTypeFields<BehavioralPhysicalExaminationCreateUpdateSerializer> = [
	{
		_class: 'GeneralExam',
		fields: GeneralExam,
		key: 'general_exam',
		label: 'General',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'SkinExam',
		fields: SkinExam,
		key: 'skin_exam',
		label: 'Skin',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'EyesExam',
		fields: EyesExam,
		key: 'eyes_exam',
		label: 'Eyes',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'ENTExam',
		fields: ENTExam,
		key: 'ent_exam',
		label: 'ENT',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'NeckExam',
		fields: NeckExam,
		key: 'neck_exam',
		label: 'Neck',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'LungsExam',
		fields: LungsExam,
		key: 'lungs_exam',
		label: 'Lungs',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'HeartExam',
		fields: HeartExam,
		key: 'heart_exam',
		label: 'Heart',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'AbdomenExam',
		fields: AbdomenExam,
		key: 'abdomen_exam',
		label: 'Abdomen',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'GUExam',
		fields: GUExam,
		key: 'gu_exam',
		label: 'GU',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'MuscularExam',
		fields: MuscularExam,
		key: 'muscular_exam',
		label: 'Muscular',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		_class: 'BehavioralNeuroExam',
		fields: BehavioralNeuroExam,
		key: 'neuro_exam',
		label: 'Neuro',
		multiple: false,
		required: true,
		type: 'field_set',
	},
	{
		key: 'limited',
		label: 'Limited',
		required: false,
		type: 'boolean',
	},
	{
		key: 'limited_due_to',
		label: 'Limited due to',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'StatusObservationCreateUpdate',
		fields: StatusObservationCreateUpdate,
		key: 'status_observations',
		label: 'Status Observation',
		multiple: true,
		required: false,
		type: 'field_set',
	}
];

export const WoundReasonForVisit: TaskTypeFields<WoundReasonForVisitSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'patient_history_of_wounds',
		label: 'Patient history of wounds',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'patient_poor_diet',
		label: 'Patient poor diet',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'patient_abnormal_lab_values',
		label: 'Patient abnormal lab values',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		choices: [
			{
				key: 'SIGNIFICANT',
				label: 'Significant',
			},
			{
				key: 'UNCONTROLLED',
				label: 'Uncontrolled',
			},
			{
				key: 'MINIMAL',
				label: 'Minimal',
			},
			{
				key: 'NOT_APPLICABLE',
				label: 'Not Applicable',
			}
		],
		key: 'patient_edema',
		label: 'Patient edema',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'chief_complaint',
		label: 'Chief complaint',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient_history_of_wounds_note',
		label: 'Patient history of wounds note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'YES',
				label: 'Yes',
			},
			{
				key: 'NO',
				label: 'No',
			}
		],
		key: 'patient_immobile',
		label: 'Patient immobile',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'patient_immobile_note',
		label: 'Patient immobile note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'YES',
				label: 'Yes',
			},
			{
				key: 'NO',
				label: 'No',
			}
		],
		key: 'patient_history_of_falls',
		label: 'Patient history of falls',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'patient_history_of_falls_note',
		label: 'Patient history of falls note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'YES',
				label: 'Yes',
			},
			{
				key: 'NO',
				label: 'No',
			}
		],
		key: 'patient_with_antibiotics',
		label: 'Patient with antibiotics',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'patient_with_antibiotics_note',
		label: 'Patient with antibiotics note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient_poor_diet_note',
		label: 'Patient poor diet note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient_edema_note',
		label: 'Patient edema note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient_abnormal_lab_values_note',
		label: 'Patient abnormal lab values note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient_tobacco_use_date',
		label: 'Patient tobacco use date',
		required: false,
		type: 'date',
	},
	{
		key: 'patient_tobacco_use_note',
		label: 'Patient tobacco use note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'patient_complicating_factors',
		label: 'Patient complicating factors',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'contributing_social_family_hx',
		label: 'Contributing social family hx',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'FULL_CARE',
				label: 'Full Care (Skilled)',
			},
			{
				key: 'CUSTODIAL_CARE',
				label: 'Custodial Care',
			},
			{
				key: 'PALLIATIVE_CARE',
				label: 'Palliative care',
			},
			{
				key: 'HOSPICE',
				label: 'Hospice',
			}
		],
		key: 'goals_of_care',
		label: 'Goals of care',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'substance_abuse',
		label: 'Substance abuse',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'substance_abuse_note',
		label: 'Substance abuse note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alcohol_use',
		label: 'Alcohol use',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'alcohol_use_note',
		label: 'Alcohol use note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'task',
		label: 'Task',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'snomed_smoking_status',
		label: 'Snomed smoking status',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const WoundLocation: TaskTypeFields<WoundLocationSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'side',
		label: 'Side',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'display_name',
		label: 'Display name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'anatomical_location',
		label: 'Anatomical location',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'anatomical_modifiers',
		label: 'Anatomical modifiers',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	}
];

export const WoundCreate: TaskTypeFields<WoundCreateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'original_task_id',
		label: 'Original task id',
		required: false,
	},
	{
		_class: 'WoundLocation',
		fields: WoundLocation,
		key: 'wound_location',
		label: 'Wound location',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'created_at',
		label: 'Created at',
		required: false,
		type: 'datetime',
	},
	{
		key: 'modified_at',
		label: 'Modified at',
		required: false,
		type: 'datetime',
	},
	{
		key: 'wound_identifier',
		label: 'Wound identifier',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'date',
		label: 'Date',
		required: false,
		type: 'datetime',
	},
	{
		key: 'date_unknown',
		label: 'Date unknown',
		required: false,
		type: 'boolean',
	},
	{
		choices: [
			{
				key: 'PRESENT_ON_ADMISSION',
				label: 'Present on Admission',
			},
			{
				key: 'ACQUIRED_IN_HOUSE',
				label: 'Acquired In-House',
			}
		],
		key: 'present_on_admission',
		label: 'Present on admission',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'date_of_referral',
		label: 'Date of referral',
		required: false,
		type: 'date',
	},
	{
		key: 'above_knee',
		label: 'Above knee',
		required: false,
		type: 'boolean',
	},
	{
		key: 'location',
		label: 'Location',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'position_associated_wound',
		label: 'Position associated wound',
		required: false,
		type: 'boolean',
	},
	{
		choices: [
			{
				key: 'PRESSURE_ULCER',
				label: 'Pressure Ulcer',
			},
			{
				key: 'ARTERIAL_ULCER',
				label: 'Arterial Ulcer',
			},
			{
				key: 'DIABETIC_ULCER',
				label: 'Diabetic Ulcer',
			},
			{
				key: 'VENOUS_STASIS_ULCER',
				label: 'Venous Stasis Ulcer',
			},
			{
				key: 'SURGICAL_WOUND',
				label: 'Surgical Wound',
			},
			{
				key: 'LACERATION',
				label: 'Laceration',
			},
			{
				key: 'BRUISE',
				label: 'Bruise',
			},
			{
				key: 'SKIN_TEAR',
				label: 'Skin Tear',
			},
			{
				key: 'ABRASION',
				label: 'Abrasion',
			},
			{
				key: 'OTHER',
				label: 'Other',
			}
		],
		key: 'wound_type',
		label: 'Wound type',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'patient',
		label: 'Patient',
		multiple: false,
		required: true,
		type: 'foreign_key_select',
	}
];

export const SecondaryDxId: TaskTypeFields<SecondaryDxIdSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: true,
		type: 'number',
	},
	{
		key: 'name',
		label: 'Name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const WoundAssessmentCreate: TaskTypeFields<WoundAssessmentCreateSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'exudate_amount',
		label: 'Exudate amount',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'exudate_consistency',
		label: 'Exudate consistency',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'exudate_odor',
		label: 'Exudate odor',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'wound_pain_occasion',
		label: 'Wound pain occasion',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'periwound_other',
		label: 'Periwound other',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'wound_edge_state',
		label: 'Wound edge state',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'tracking',
		label: 'Tracking',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		_class: 'SecondaryDxId',
		fields: SecondaryDxId,
		key: 'secondary_dx',
		label: 'Secondary dx',
		multiple: true,
		required: false,
		type: 'field_set',
	},
	{
		key: 'precautions',
		label: 'Precautions',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'procedure',
		label: 'Procedure',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'parsed_wounds',
		label: 'Parsed wounds',
		multiple: true,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'is_deleted',
		label: 'Is deleted',
		required: false,
		type: 'boolean',
	},
	{
		key: 'created_at',
		label: 'Created at',
		required: false,
		type: 'datetime',
	},
	{
		key: 'modified_at',
		label: 'Modified at',
		required: false,
		type: 'datetime',
	},
	{
		key: 'unmeasurable_wound',
		label: 'Unmeasurable wound',
		required: false,
		type: 'boolean',
	},
	{
		key: 'wound_dimensions',
		label: 'Wound dimensions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'wound_length',
		label: 'Wound length',
		required: false,
		type: 'number',
	},
	{
		key: 'wound_length_utd',
		label: 'Wound length utd',
		required: false,
		type: 'boolean',
	},
	{
		key: 'wound_width',
		label: 'Wound width',
		required: false,
		type: 'number',
	},
	{
		key: 'wound_width_utd',
		label: 'Wound width utd',
		required: false,
		type: 'boolean',
	},
	{
		key: 'wound_depth',
		label: 'Wound depth',
		required: false,
		type: 'number',
	},
	{
		key: 'wound_depth_utd',
		label: 'Wound depth utd',
		required: false,
		type: 'boolean',
	},
	{
		key: 'wound_size_unit',
		label: 'Wound size unit',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'granulation_total',
		label: 'Granulation total',
		required: false,
		type: 'number',
	},
	{
		key: 'healthy_epithelialization',
		label: 'Healthy epithelialization',
		required: false,
		type: 'number',
	},
	{
		key: 'scab',
		label: 'Scab',
		required: false,
		type: 'boolean',
	},
	{
		key: 'scab_note',
		label: 'Scab note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'necrotic_slough',
		label: 'Necrotic slough',
		required: false,
		type: 'number',
	},
	{
		key: 'necrotic_eschar',
		label: 'Necrotic eschar',
		required: false,
		type: 'number',
	},
	{
		key: 'exposed_structure',
		label: 'Exposed structure',
		required: false,
		type: 'boolean',
	},
	{
		key: 'exposed_structure_note',
		label: 'Exposed structure note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'NORMAL',
				label: 'Normal',
			},
			{
				key: 'REDNESS',
				label: 'Redness (Erythema)',
			},
			{
				key: 'PALLOR',
				label: 'Pallor',
			},
			{
				key: 'DARKENING',
				label: 'Darkening/Bluish Tinge',
			}
		],
		key: 'periwound_color',
		label: 'Periwound color',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'NORMAL_TEXTURE',
				label: 'Normal',
			},
			{
				key: 'DRY_SCALY',
				label: 'Dry/Scaly',
			},
			{
				key: 'MACERATED',
				label: 'Macerated',
			},
			{
				key: 'EXCORIATED',
				label: 'Excoriated',
			},
			{
				key: 'CALLOUS',
				label: 'Callous',
			}
		],
		key: 'periwound_texture',
		label: 'Periwound texture',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'periwound_comment',
		label: 'Periwound comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'exudate_comment',
		label: 'Exudate comment',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'wound_pain_note',
		label: 'Wound pain note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'adequate_treatment',
		label: 'Adequate treatment',
		required: false,
		type: 'boolean',
	},
	{
		key: 'adequate_treatment_note',
		label: 'Adequate treatment note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'AUTOLYTIC',
				label: 'Autolytic',
			},
			{
				key: 'ENZYMATIC',
				label: 'Enzymatic',
			},
			{
				key: 'MECHANICAL',
				label: 'Mechanical',
			},
			{
				key: 'SHARP_SURGICAL',
				label: 'Sharp/Surgical',
			},
			{
				key: 'BIOLOGICAL',
				label: 'Biological',
			}
		],
		key: 'wound_plan',
		label: 'Wound plan',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'wound_plan_comments',
		label: 'Wound plan comments',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'after_plan_unmeasurable_wound',
		label: 'After plan unmeasurable wound',
		required: false,
		type: 'boolean',
	},
	{
		key: 'after_plan_wound_length',
		label: 'After plan wound length',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'after_plan_wound_width',
		label: 'After plan wound width',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'after_plan_wound_depth',
		label: 'After plan wound depth',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'after_plan_wound_dimensions',
		label: 'After plan wound dimensions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'precautions_note',
		label: 'Precautions note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'factors',
		label: 'Factors',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'testing',
		label: 'Testing',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'nursing_orders',
		label: 'Nursing orders',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'primary_dx_note',
		label: 'Primary dx note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'secondary_dx_note',
		label: 'Secondary dx note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'SUPERFICIAL_WOUNDS_LOW',
				label: 'Superficial Wounds (Low)',
			},
			{
				key: 'PARTIAL_THICKNESS_WOUNDS_MILD_TO_MODERATE',
				label: 'Partial-Thickness Wounds (Mild to Moderate)',
			},
			{
				key: 'FULL_THICKNESS_WOUNDS_MODERATE_TO_HIGH',
				label: 'Full-Thickness Wounds (Moderate to High)',
			},
			{
				key: 'WOUNDS_WITH_NECROSIS_OR_INFECTION_HIGH',
				label: 'Wounds with Necrosis or Infection (High)',
			},
			{
				key: 'CHRONIC_OR_NON_HEALING_WOUNDS_HIGHEST',
				label: 'Chronic or Non-Healing Wounds (Highest)',
			}
		],
		key: 'wound_classification',
		label: 'Wound classification',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'GRADE_0',
				label: 'Grade 0: Intact skin with no open lesions',
			},
			{
				key: 'GRADE_1',
				label: 'Grade I: Superficial ulcer involving only the epidermis and dermis',
			},
			{
				key: 'GRADE_2',
				label: 'Grade II: Deep ulcer extending into subcutaneous tissue',
			},
			{
				key: 'GRADE_3',
				label: 'Grade III: Deep ulcer with abscess, osteomyelitis (bone infection), or joint sepsis',
			},
			{
				key: 'GRADE_4',
				label: 'Grade IV: Localized gangrene (death of tissue) involving part of the foot, such as toes or the heel',
			},
			{
				key: 'GRADE_5',
				label: 'Grade V: Extensive gangrene involving the entire foot',
			},
			{
				key: 'STAGE_1',
				label: 'Stage I: Non-blanchable redness',
			},
			{
				key: 'STAGE_2',
				label: 'Stage II: Partial-thickness skin loss, appearing like an open blister',
			},
			{
				key: 'STAGE_3',
				label: 'Stage III: Full-thickness skin loss, possibly exposing fat, with risk of infection',
			},
			{
				key: 'STAGE_4',
				label: 'Stage IV: Full-thickness tissue loss with exposure of muscle, bone, or tendon, posing serious infection risks',
			},
			{
				key: 'DTI',
				label: 'DTI: Injury where the skin appears intact but there is underlying damage to soft tissues',
			},
			{
				key: 'UNSTAGEABLE',
				label: 'Unstageable: Extent of tissue damage cannot be accurately assessed',
			}
		],
		key: 'wagner_classification',
		label: 'Wagner classification',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'STAGE_1',
				label: 'Stage I: Non-blanchable redness',
			},
			{
				key: 'STAGE_2',
				label: 'Stage II: Partial-thickness skin loss, appearing like an open blister',
			},
			{
				key: 'STAGE_3',
				label: 'Stage III: Full-thickness skin loss, possibly exposing fat, with risk of infection',
			},
			{
				key: 'STAGE_4',
				label: 'Stage IV: Full-thickness tissue loss with exposure of muscle, bone, or tendon, posing serious infection risks',
			},
			{
				key: 'DTI',
				label: 'DTI: Injury where the skin appears intact but there is underlying damage to soft tissues',
			},
			{
				key: 'UNSTAGEABLE',
				label: 'Unstageable: Extent of tissue damage cannot be accurately assessed',
			}
		],
		key: 'pressure_ulcer_classification',
		label: 'Pressure ulcer classification',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'DETERIORATING',
				label: 'Deteriorating',
			},
			{
				key: 'MINIMAL_IMPROVEMENT',
				label: 'No to Minimal Improvement',
			},
			{
				key: 'IMPROVING',
				label: 'Improving/Healing',
			},
			{
				key: 'CLOSED',
				label: 'Closed/Healed',
			}
		],
		key: 'wound_progression',
		label: 'Wound progression',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'SUPERFICIAL_WOUNDS_LOW',
				label: 'Superficial Wounds (Low)',
			},
			{
				key: 'PARTIAL_THICKNESS_WOUNDS_MILD_TO_MODERATE',
				label: 'Partial-Thickness Wounds (Mild to Moderate)',
			},
			{
				key: 'FULL_THICKNESS_WOUNDS_MODERATE_TO_HIGH',
				label: 'Full-Thickness Wounds (Moderate to High)',
			},
			{
				key: 'WOUNDS_WITH_NECROSIS_OR_INFECTION_HIGH',
				label: 'Wounds with Necrosis or Infection (High)',
			},
			{
				key: 'CHRONIC_OR_NON_HEALING_WOUNDS_HIGHEST',
				label: 'Chronic or Non-Healing Wounds (Highest)',
			},
			{
				key: 'STAGE_1',
				label: 'Stage I: Non-blanchable redness',
			},
			{
				key: 'STAGE_2',
				label: 'Stage II: Partial-thickness skin loss, appearing like an open blister',
			},
			{
				key: 'STAGE_3',
				label: 'Stage III: Full-thickness skin loss, possibly exposing fat, with risk of infection',
			},
			{
				key: 'STAGE_4',
				label: 'Stage IV: Full-thickness tissue loss with exposure of muscle, bone, or tendon, posing serious infection risks',
			},
			{
				key: 'DTI',
				label: 'DTI: Injury where the skin appears intact but there is underlying damage to soft tissues',
			},
			{
				key: 'UNSTAGEABLE',
				label: 'Unstageable: Extent of tissue damage cannot be accurately assessed',
			}
		],
		key: 'arterial_ulcer_classification',
		label: 'Arterial ulcer classification',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'location_note',
		label: 'Location note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'position_associated_wound_note',
		label: 'Position associated wound note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'infected',
		label: 'Infected',
		required: false,
		type: 'boolean',
	},
	{
		key: 'infected_note',
		label: 'Infected note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'date_of_service',
		label: 'Date of service',
		required: false,
		type: 'date',
	},
	{
		key: 'status',
		label: 'Status',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sales_order_id',
		label: 'Sales order id',
		required: false,
		type: 'number',
	},
	{
		key: 'sales_order_date',
		label: 'Sales order date',
		required: false,
		type: 'date',
	},
	{
		key: 'sales_order_dx_id',
		label: 'Sales order dx id',
		required: false,
		type: 'number',
	},
	{
		key: 'sales_order_entry_id',
		label: 'Sales order entry id',
		required: false,
		type: 'number',
	},
	{
		key: 'primary_dx',
		label: 'Primary dx',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'created_by',
		label: 'Created by',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const ICDCodeName: TaskTypeFields<ICDCodeNameSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'name',
		label: 'Name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'description',
		label: 'Description',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const DressingOrderForPartBItem: TaskTypeFields<DressingOrderForPartBItemSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		_class: 'ICDCodeName',
		fields: ICDCodeName,
		key: 'diagnosis',
		label: 'Diagnosis',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'primary_dressings',
		label: 'Primary dressings',
		required: true,
	},
	{
		key: 'secondary_dressings',
		label: 'Secondary dressings',
		required: true,
	},
	{
		key: 'securements',
		label: 'Securements',
		required: true,
	},
	{
		key: 'created_at',
		label: 'Created at',
		required: false,
		type: 'datetime',
	},
	{
		key: 'modified_at',
		label: 'Modified at',
		required: false,
		type: 'datetime',
	},
	{
		key: 'clean_prep_instructions',
		label: 'Clean prep instructions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'frequency',
		label: 'Frequency',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'dispense',
		label: 'Dispense',
		required: false,
		type: 'number',
	},
	{
		key: 'instructions',
		label: 'Instructions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		choices: [
			{
				key: 'RECURRING',
				label: 'Recurring',
			},
			{
				key: 'NEW',
				label: 'New',
			},
			{
				key: 'PENDING',
				label: 'Pending',
			},
			{
				key: 'APPROVED',
				label: 'Approved',
			},
			{
				key: 'COMPLETED',
				label: 'Completed',
			},
			{
				key: 'REJECTED',
				label: 'Rejected',
			}
		],
		key: 'status',
		label: 'Status',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'wound',
		label: 'Wound',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	},
	{
		key: 'part_b_item',
		label: 'Part b item',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const WoundAction: TaskTypeFields<WoundActionSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: false,
		type: 'number',
	},
	{
		_class: 'WoundCreate',
		fields: WoundCreate,
		key: 'wound',
		label: 'Wound',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'WoundAssessmentCreate',
		fields: WoundAssessmentCreate,
		key: 'wound_assessment',
		label: 'Wound assessment',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'action',
		label: 'Action',
		multiple: false,
		required: true,
		type: 'text',
	},
	{
		_class: 'DressingOrderForPartBItem',
		fields: DressingOrderForPartBItem,
		key: 'dressing_order',
		label: 'Dressing order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'RXOrder',
		fields: RXOrder,
		key: 'rx_order',
		label: 'Rx order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'LabOrder',
		fields: LabOrder,
		key: 'lab_order',
		label: 'Lab order',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		_class: 'OtherOrder',
		fields: OtherOrder,
		key: 'other_order',
		label: 'Other order',
		multiple: false,
		required: false,
		type: 'field_set',
	}
];

export const WoundReview: TaskTypeFields<WoundReviewSerializer> = [
	{
		key: 'id',
		label: 'Id',
		required: false,
		type: 'number',
	},
	{
		_class: 'WoundAction',
		fields: WoundAction,
		key: 'actions',
		label: 'Actions',
		multiple: true,
		required: true,
		type: 'field_set',
	}
];

export const CognitiveReasonForVisit: TaskTypeFields<CognitiveReasonForVisitSerializer> = [
	{
		key: 'patient_description',
		label: 'Patient description',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'high_risk_medications',
		label: 'High risk medications',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'ongoing_medical_problems',
		label: 'Ongoing medical problems',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cognitive_reason_for_visit_social_history',
		label: 'Cognitive reason for visit social history',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cognitive_reason_for_visit_family_history',
		label: 'Cognitive reason for visit family history',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const CognitiveSymptomsOfIllness: TaskTypeFields<CognitiveSymptomsOfIllnessSerializer> = [
	{
		key: 'sleep_disruptions',
		label: 'Sleep disruptions',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sleep_disruptions_note',
		label: 'Sleep disruptions note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'fatigue',
		label: 'Fatigue',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'fatigue_note',
		label: 'Fatigue note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'impaired_concentration',
		label: 'Impaired concentration',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'impaired_concentration_note',
		label: 'Impaired concentration note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'guilt',
		label: 'Guilt',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'guilt_note',
		label: 'Guilt note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lack_of_pleasure',
		label: 'Lack of pleasure',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'lack_of_pleasure_note',
		label: 'Lack of pleasure note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'appetite',
		label: 'Appetite',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'appetite_note',
		label: 'Appetite note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychomotor',
		label: 'Psychomotor',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'psychomotor_note',
		label: 'Psychomotor note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'suicidal_ideation',
		label: 'Suicidal ideation',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'suicidal_ideation_note',
		label: 'Suicidal ideation note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const CognitiveBaselineEvaluation: TaskTypeFields<CognitiveBaselineEvaluationSerializer> = [
	{
		key: 'intelligence',
		label: 'Intelligence',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'intelligence_note',
		label: 'Intelligence note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cognition',
		label: 'Cognition',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'cognition_note',
		label: 'Cognition note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'concentration',
		label: 'Concentration',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'concentration_note',
		label: 'Concentration note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'age',
		label: 'Age',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'age_note',
		label: 'Age note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'physique',
		label: 'Physique',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'physique_note',
		label: 'Physique note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'insight_and_judgement',
		label: 'Insight and judgement',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'insight_and_judgement_note',
		label: 'Insight and judgement note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'memory',
		label: 'Memory',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'memory_note',
		label: 'Memory note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const PHQ9: TaskTypeFields<PHQ9Serializer> = [
	{
		key: 'interest',
		label: 'Interest',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'interest_note',
		label: 'Interest note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'depression',
		label: 'Depression',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'depression_note',
		label: 'Depression note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sleeping',
		label: 'Sleeping',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'sleeping_note',
		label: 'Sleeping note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'tiredness',
		label: 'Tiredness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'tiredness_note',
		label: 'Tiredness note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'appetite',
		label: 'Appetite',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'appetite_note',
		label: 'Appetite note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'self_hate',
		label: 'Self hate',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'self_hate_note',
		label: 'Self hate note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'concentration',
		label: 'Concentration',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'concentration_note',
		label: 'Concentration note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'slowness',
		label: 'Slowness',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'slowness_note',
		label: 'Slowness note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'suicidal_tendencies',
		label: 'Suicidal tendencies',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'suicidal_tendencies_note',
		label: 'Suicidal tendencies note',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'score',
		label: 'Score',
		required: false,
		type: 'number',
	},
	{
		key: 'score_note',
		label: 'Score note',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const CognitiveFastScreening: TaskTypeFields<CognitiveFastScreeningSerializer> = [
	{
		key: 'no_problem',
		label: 'No problem',
		required: false,
		type: 'boolean',
	},
	{
		key: 'forgetting_locations',
		label: 'Forgetting locations',
		required: false,
		type: 'boolean',
	},
	{
		key: 'decreased_functioning',
		label: 'Decreased functioning',
		required: false,
		type: 'boolean',
	},
	{
		key: 'problematic_functioning',
		label: 'Problematic functioning',
		required: false,
		type: 'boolean',
	},
	{
		key: 'needs_help_clothing',
		label: 'Needs help clothing',
		required: false,
		type: 'boolean',
	},
	{
		key: 'problems_with_adls',
		label: 'Problems with adls',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'limited_speech',
		label: 'Limited speech',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'score',
		label: 'Score',
		required: false,
		type: 'number',
	}
];

export const CognitiveCarePlan: TaskTypeFields<CognitiveCarePlanSerializer> = [
	{
		key: 'dementia_plan',
		label: 'Dementia plan',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'neuro_psychiatric_symptoms',
		label: 'Neuro psychiatric symptoms',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'safety_management',
		label: 'Safety management',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'care_giver_support_meeting',
		label: 'Care giver support meeting',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'advanced_care_plan',
		label: 'Advanced care plan',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const FHIRQuestionnaireResponseItem: TaskTypeFields<FHIRQuestionnaireResponseItemSerializer> = [
	{
		key: 'item_path',
		label: 'Item path',
		multiple: false,
		required: true,
		type: 'text',
	},
	{
		key: 'value_string',
		label: 'Value string',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'value_decimal',
		label: 'Value decimal',
		required: false,
		type: 'number',
	},
	{
		key: 'value_coding',
		label: 'Value coding',
		multiple: false,
		required: false,
		type: 'select',
	}
];

export const FHIRQuestionnaireResponse: TaskTypeFields<FHIRQuestionnaireResponseSerializer> = [
	{
		key: 'id',
		label: 'ID',
		required: false,
		type: 'number',
	},
	{
		key: 'questionnaire',
		label: 'Questionnaire',
		multiple: false,
		required: true,
		type: 'foreign_key_select',
	},
	{
		_class: 'FHIRQuestionnaireResponseItem',
		fields: FHIRQuestionnaireResponseItem,
		key: 'items',
		label: 'Items',
		multiple: true,
		required: true,
		type: 'field_set',
	},
	{
		key: 'task',
		label: 'Task',
		multiple: false,
		required: false,
		type: 'foreign_key_select',
	}
];

export const PatientAdditionalName: TaskTypeFields<PatientAdditionalNameSerializer> = [
	{
		choices: [
			{
				key: 'NAME_USE_A',
				label: 'Artist/Stage',
			},
			{
				key: 'NAME_USE_ABC',
				label: 'Alphabetic',
			},
			{
				key: 'NAME_USE_ASGN',
				label: 'assigned',
			},
			{
				key: 'NAME_USE_C',
				label: 'License',
			},
			{
				key: 'NAME_USE_I',
				label: 'Indigenous/Tribal',
			},
			{
				key: 'NAME_USE_IDE',
				label: 'Ideographic',
			},
			{
				key: 'NAME_USE_L',
				label: 'Legal',
			},
			{
				key: 'NAME_USE_OR',
				label: 'official registry',
			},
			{
				key: 'NAME_USE_P',
				label: 'pseudonym',
			},
			{
				key: 'NAME_USE_PHON',
				label: 'phonetic',
			},
			{
				key: 'NAME_USE_R',
				label: 'Religious',
			},
			{
				key: 'NAME_USE_SNDX',
				label: 'Soundex',
			},
			{
				key: 'NAME_USE_SRCH',
				label: 'search',
			},
			{
				key: 'NAME_USE_SYL',
				label: 'Syllabic',
			}
		],
		key: 'use',
		label: 'Use',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		choices: [
			{
				key: 'NAME_QUALIFIER_AC',
				label: 'academic',
			},
			{
				key: 'NAME_QUALIFIER_AD',
				label: 'adopted',
			},
			{
				key: 'NAME_QUALIFIER_BR',
				label: 'birth',
			},
			{
				key: 'NAME_QUALIFIER_BL',
				label: 'billable',
			},
			{
				key: 'NAME_QUALIFIER_CL',
				label: 'callme',
			},
			{
				key: 'NAME_QUALIFIER_IN',
				label: 'initial',
			},
			{
				key: 'NAME_QUALIFIER_NB',
				label: 'nobility',
			},
			{
				key: 'NAME_QUALIFIER_PR',
				label: 'professional',
			},
			{
				key: 'NAME_QUALIFIER_SP',
				label: 'spouse',
			},
			{
				key: 'NAME_QUALIFIER_TITLE',
				label: 'title',
			},
			{
				key: 'NAME_QUALIFIER_VV',
				label: 'voorvoegsel',
			}
		],
		key: 'qualifier',
		label: 'Qualifier',
		multiple: false,
		required: false,
		type: 'select',
	},
	{
		key: 'first_name',
		label: 'First name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'middle_name',
		label: 'Middle name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'last_name',
		label: 'Last name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'prefix',
		label: 'Prefix',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'suffix',
		label: 'Suffix',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'start',
		label: 'Start',
		required: false,
		type: 'date',
	},
	{
		key: 'end',
		label: 'End',
		required: false,
		type: 'date',
	}
];

export const PatientInformation: TaskTypeFields<PatientInformationSerializer> = [
	{
		key: 'first_name',
		label: 'First name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'last_name',
		label: 'Last name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'middle_name',
		label: 'Middle name',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'date_ob',
		label: 'Date ob',
		required: false,
		type: 'date',
	},
	{
		key: 'date_of_decease',
		label: 'Date of decease',
		required: false,
		type: 'datetime',
	},
	{
		key: 'reason_of_decease',
		label: 'Reason of decease',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'name_prefix',
		label: 'Name prefix',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'name_suffix',
		label: 'Name suffix',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		_class: 'PatientAdditionalName',
		fields: PatientAdditionalName,
		key: 'patient_additional_names',
		label: 'Patient additional names',
		multiple: true,
		required: false,
		type: 'field_set',
	}
];

export const Demographics: TaskTypeFields<DemographicsSerializer> = [
	{
		key: 'administrative_gender',
		label: 'Administrative gender',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'birth_sex',
		label: 'Birth sex',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'gender_identity',
		label: 'Gender identity',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'language',
		label: 'Language',
		multiple: false,
		required: false,
		type: 'text',
	},
	{
		key: 'races',
		label: 'Races',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'ethnicities',
		label: 'Ethnicities',
		multiple: false,
		required: false,
		type: 'field_set',
	},
	{
		key: 'sexual_orientation',
		label: 'Sexual orientation',
		multiple: false,
		required: false,
		type: 'text',
	}
];

export const RpmBillingTaskType: TaskTypeDefinition = {
	default_duration: 8,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'RPM_BILLING',
	name: 'RPM Billing',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const FacilityContactPatientConcernsTaskType: TaskTypeDefinition = {
	default_duration: 5,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'FACILITY_CONTACT_PATIENT_CONCERNS',
	name: 'Contact with Facility re: Patient Concerns',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_BROADSTREET',
		'ROLE_SED_TESTING',
		'ROLE_VCM_LITE',
	],
};

export const CdaReconcileTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CDA_RECONCILE',
	name: 'C-CDA Reconciliation',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_BROADSTREET',
		'ROLE_SED_TESTING',
	],
};

export const RxReconcileTaskType: TaskTypeDefinition = {
	default_duration: 3,
	extra_fields: [
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'RX_RECONCILE',
	name: 'RX Reconcile',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
	],
};

export const DxReviewTaskType: TaskTypeDefinition = {
	default_duration: 15,
	extra_fields: [
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'DX_REVIEW',
	name: 'DX Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_SUPER_ADMIN',
	],
};

export const LabReviewTaskType: TaskTypeDefinition = {
	default_duration: 3,
	extra_fields: [
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			icon: 'vial',
			key: 'lab_test_review',
			label: 'Lab Test Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewRead',
			fields: ImagingResultReviewRead,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewRead',
			fields: ClinicalTestResultReviewRead,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicianOrder',
			fields: PhysicianOrder,
			key: 'physician_order',
			label: 'Orders',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'LAB_REVIEW',
	name: 'Results Review',
	need_to_fax: true,
	need_to_sms: false,
};

export const FollowingPatientsTaskType: TaskTypeDefinition = {
	default_duration: 3,
	deprecated: true,
	extra_fields: [
		{
			_class: 'EventReview',
			fields: EventReview,
			icon: 'exclamation-triangle',
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			icon: 'clipboard-list-check',
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'FOLLOWING_PATIENTS',
	name: 'Following Patients',
	need_to_fax: false,
	need_to_sms: false,
};

export const CriticalVitalsTaskType: TaskTypeDefinition = {
	default_duration: 3,
	extra_fields: [
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalReview',
			fields: VitalReview,
			key: 'vital_review',
			label: 'Vital review',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CRITICAL_VITALS',
	name: 'Critical Vitals',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_SED_TESTING',
		'ROLE_VCM_LITE',
	],
};

export const GeneralReviewTaskType: TaskTypeDefinition = {
	default_duration: 5,
	extra_fields: [
		{
			_class: 'EventReview',
			fields: EventReview,
			icon: 'exclamation-triangle',
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			icon: 'clipboard-list-check',
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'GENERAL_REVIEW',
	name: 'General Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
	],
};

export const RemoteMonitorTaskType: TaskTypeDefinition = {
	children: [
		GeneralReviewTaskType,
		CriticalVitalsTaskType,
		FollowingPatientsTaskType,
		LabReviewTaskType,
		DxReviewTaskType,
		RxReconcileTaskType,
		CdaReconcileTaskType,
		FacilityContactPatientConcernsTaskType,
		RpmBillingTaskType
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'REMOTE_MONITOR',
	name: 'Remote Monitor',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const GpcNarrativeTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'WoundReasonForVisit',
			fields: WoundReasonForVisit,
			key: 'wound_reason_for_visit',
			label: 'Reason for Visit',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: true,
	key: 'GPC_NARRATIVE',
	name: 'GPC Narrative',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
	],
};

export const UrgentAcuteTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: true,
	key: 'URGENT_ACUTE',
	name: 'Urgent Acute',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_NP_TEAM_MEMBER',
	],
};

export const EarClinicTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: true,
	key: 'EAR_CLINIC',
	name: 'Ear Clinic',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_CLINIC',
	],
};

export const InjectionClinicTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: true,
	key: 'INJECTION_CLINIC',
	name: 'Injection Clinic',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_CLINIC',
	],
};

export const AnnualWellnessExamTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: true,
	key: 'ANNUAL_WELLNESS_EXAM',
	name: 'Annual Wellness Exam',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_SUBSPECIALIST',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const CognitiveAssessmentTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'CognitiveReasonForVisit',
			fields: CognitiveReasonForVisit,
			key: 'cognitive_reason_for_visit',
			label: 'Cognitive Reason For Visit',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'CognitiveSymptomsOfIllness',
			fields: CognitiveSymptomsOfIllness,
			key: 'cognitive_symptoms_of_illness',
			label: 'Cognitive Symptoms Of Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'CognitiveBaselineEvaluation',
			fields: CognitiveBaselineEvaluation,
			key: 'cognitive_baseline_evaluation',
			label: 'Cognitive Baseline Evaluation',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralMentalStatusExamCreateUpdate',
			fields: BehavioralMentalStatusExamCreateUpdate,
			key: 'mental_status_exam',
			label: 'Mental Status Exam',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PHQ9',
			fields: PHQ9,
			key: 'phq_9',
			label: 'PHQ-9',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'CognitiveFastScreening',
			fields: CognitiveFastScreening,
			key: 'cognitive_fast_screening',
			label: 'Cognitive FAST Screening',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'CognitiveCarePlan',
			fields: CognitiveCarePlan,
			key: 'cognitive_care_plan',
			label: 'Cognitive Care Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: true,
	is_progress_note: true,
	is_visit: true,
	key: 'COGNITIVE_ASSESSMENT',
	name: 'Cognitive Assessment',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_BEHAVIORAL_PHYSICIAN',
	],
};

export const VisitTelehealthTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: true,
	key: 'VISIT_TELEHEALTH',
	name: 'Telehealth',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const VisitFaceToFaceTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: true,
	key: 'VISIT_FACE_TO_FACE',
	name: 'Face-to-Face',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_NP_ALL',
		'ROLE_NP_ASSIGNED',
		'ROLE_VCM_LITE',
	],
};

export const VisitFollowUpCareNoteTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'VISIT_FOLLOW_UP_CARE_NOTE',
	name: 'Follow+Up Care Note',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const GroupTherapyTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: true,
	key: 'GROUP_THERAPY',
	name: 'Group Therapy',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
	],
};

export const MinimalWoundAssessmentTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'WoundReview',
			fields: WoundReview,
			key: 'wound_review',
			label: 'Wound Review',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'MINIMAL_WOUND_ASSESSMENT',
	name: 'Wound Assessment',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_WOUND_PHYSICIAN',
	],
};

export const WoundAssessmentTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'WoundReasonForVisit',
			fields: WoundReasonForVisit,
			key: 'wound_reason_for_visit',
			label: 'Wound Reason For Visit',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'WoundReview',
			fields: WoundReview,
			key: 'wound_review',
			label: 'Wound Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: true,
	key: 'WOUND_ASSESSMENT',
	name: 'Wound Consult',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_WOUND_PHYSICIAN',
	],
};

export const MentalStatusExamTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralPastPsychiatricHistory',
			fields: BehavioralPastPsychiatricHistory,
			key: 'past_psychiatric_history',
			label: 'Past Psychiatric History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralSocialHistory',
			fields: BehavioralSocialHistory,
			key: 'behavioral_social_history',
			label: 'Behavioral Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralFamilyHistory',
			fields: BehavioralFamilyHistory,
			key: 'behavioral_family_history',
			label: 'Behavioral Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralDevelopmentalHistory',
			fields: BehavioralDevelopmentalHistory,
			key: 'developmental_history',
			label: 'Developmental History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralPsychosocialCircumstancesInfluencingHealthStatus',
			fields: BehavioralPsychosocialCircumstancesInfluencingHealthStatus,
			key: 'psychosocial_circumstances',
			label: 'Psychosocial Circumstances Influencing Health Status',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralSymptomsOfIllness',
			fields: BehavioralSymptomsOfIllness,
			key: 'symptoms_of_illness',
			label: 'Symptoms Of Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralBaselineEvaluation',
			fields: BehavioralBaselineEvaluation,
			key: 'baseline_evaluation',
			label: 'Behavioral Baseline Evaluation',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralTraumaEvaluation',
			fields: BehavioralTraumaEvaluation,
			key: 'trauma_evaluation',
			label: 'Trauma Evaluation',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralPatientAwarenessOfConsequencesOfIllnessAndBehaviorOn',
			fields: BehavioralPatientAwarenessOfConsequencesOfIllnessAndBehaviorOn,
			key: 'awareness_of_consequences',
			label: 'Behavioral Patient Awareness Of Consequences Of Illness And Behavior On',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralReviewOfSystems',
			fields: BehavioralReviewOfSystems,
			key: 'behavioral_review_of_systems',
			label: 'Behavioral Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralMentalStatusExamCreateUpdate',
			fields: BehavioralMentalStatusExamCreateUpdate,
			key: 'mental_status_exam',
			label: 'Mental Status Exam',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralPhysicalExaminationCreateUpdate',
			fields: BehavioralPhysicalExaminationCreateUpdate,
			key: 'behavioral_physical_examination',
			label: 'Behavioral Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: true,
	is_progress_note: true,
	is_visit: true,
	key: 'MENTAL_STATUS_EXAM',
	name: 'Mental Status Exam (MSE)',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_BEHAVIORAL_PHYSICIAN',
	],
};

export const VisitRoutineTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: true,
	key: 'VISIT_ROUTINE',
	name: 'Routine',
	need_to_fax: false,
	need_to_sms: false,
};

export const VisitAcuteTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: true,
	key: 'VISIT_ACUTE',
	name: 'Acute (Episodic)',
	need_to_fax: false,
	need_to_sms: false,
};

export const VisitSkilledTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: true,
	key: 'VISIT_SKILLED',
	name: 'Skilled',
	need_to_fax: false,
	need_to_sms: false,
};

export const VisitHpTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: true,
	key: 'VISIT_HP',
	name: 'H&P',
	need_to_fax: false,
	need_to_sms: false,
};

export const VisitTaskType: TaskTypeDefinition = {
	children: [
		VisitHpTaskType,
		VisitSkilledTaskType,
		VisitAcuteTaskType,
		VisitRoutineTaskType,
		MentalStatusExamTaskType,
		WoundAssessmentTaskType,
		MinimalWoundAssessmentTaskType,
		GroupTherapyTaskType,
		VisitFollowUpCareNoteTaskType,
		VisitFaceToFaceTaskType,
		VisitTelehealthTaskType,
		CognitiveAssessmentTaskType,
		AnnualWellnessExamTaskType,
		InjectionClinicTaskType,
		EarClinicTaskType,
		UrgentAcuteTaskType,
		GpcNarrativeTaskType
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: true,
	key: 'VISIT',
	name: 'Visit',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_SUBSPECIALIST',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_SCRIBE',
	],
};

export const FhirQuestionnaireTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'FHIRQuestionnaireResponse',
			fields: FHIRQuestionnaireResponse,
			key: 'questionnaire_responses',
			label: 'Questionnaire',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'FHIR_QUESTIONNAIRE',
	name: 'Questionnaire',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const VisitNewOrdersTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'PhysicianOrder',
			fields: PhysicianOrder,
			key: 'physician_order',
			label: 'Orders',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'VISIT_NEW_ORDERS',
	name: 'New Orders (POS)',
	need_to_fax: false,
	need_to_sms: false,
};

export const InPersonTaskType: TaskTypeDefinition = {
	children: [
		VisitNewOrdersTaskType,
		FhirQuestionnaireTaskType
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: true,
	key: 'IN_PERSON',
	name: 'In-Person Encounter',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const PcmReviewTaskType: TaskTypeDefinition = {
	default_duration: 25,
	extra_fields: [
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: false,
	key: 'PCM_REVIEW',
	name: 'PCM Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_VCM_LITE',
	],
};

export const PatientAccessManagementTaskType: TaskTypeDefinition = {
	default_duration: 5,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'PATIENT_ACCESS_MANAGEMENT',
	name: 'Patient Access Management',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
	],
};

export const TherapeuticInteractionReviewTaskType: TaskTypeDefinition = {
	default_duration: 20,
	extra_fields: [
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: true,
	is_progress_note: false,
	is_visit: false,
	key: 'THERAPEUTIC_INTERACTION_REVIEW',
	name: 'Therapeutic Interaction Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_SOCIAL_WORKER',
	],
};

export const BehavioralChartAuditTaskType: TaskTypeDefinition = {
	default_duration: 25,
	extra_fields: [
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralPastPsychiatricHistory',
			fields: BehavioralPastPsychiatricHistory,
			key: 'past_psychiatric_history',
			label: 'Past Psychiatric History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralSocialHistory',
			fields: BehavioralSocialHistory,
			key: 'behavioral_social_history',
			label: 'Behavioral Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralFamilyHistory',
			fields: BehavioralFamilyHistory,
			key: 'behavioral_family_history',
			label: 'Behavioral Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralDevelopmentalHistory',
			fields: BehavioralDevelopmentalHistory,
			key: 'developmental_history',
			label: 'Developmental History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralPsychosocialCircumstancesInfluencingHealthStatus',
			fields: BehavioralPsychosocialCircumstancesInfluencingHealthStatus,
			key: 'psychosocial_circumstances',
			label: 'Psychosocial Circumstances Influencing Health Status',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralSymptomsOfIllness',
			fields: BehavioralSymptomsOfIllness,
			key: 'symptoms_of_illness',
			label: 'Symptoms Of Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralBaselineEvaluation',
			fields: BehavioralBaselineEvaluation,
			key: 'baseline_evaluation',
			label: 'Behavioral Baseline Evaluation',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralTraumaEvaluation',
			fields: BehavioralTraumaEvaluation,
			key: 'trauma_evaluation',
			label: 'Trauma Evaluation',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralPatientAwarenessOfConsequencesOfIllnessAndBehaviorOn',
			fields: BehavioralPatientAwarenessOfConsequencesOfIllnessAndBehaviorOn,
			key: 'awareness_of_consequences',
			label: 'Behavioral Patient Awareness Of Consequences Of Illness And Behavior On',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: true,
	is_progress_note: false,
	is_visit: false,
	key: 'BEHAVIORAL_CHART_AUDIT',
	name: 'Behavioral Chart Audit',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_BEHAVIORAL_PHYSICIAN',
	],
};

export const ChartAuditTaskType: TaskTypeDefinition = {
	default_duration: 25,
	extra_fields: [
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CHART_AUDIT',
	name: 'Chart Audit',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_VCM_LITE',
	],
};

export const CarePlanManagementOnCallSummaryTaskType: TaskTypeDefinition = {
	default_duration: 8,
	extra_fields: [
		{
			_class: 'PhysicianOrder',
			fields: PhysicianOrder,
			key: 'physician_order',
			label: 'Orders',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_ON_CALL_SUMMARY',
	name: 'On Call Summary',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const CarePlanManagementPatientComplexityTaskType: TaskTypeDefinition = {
	default_duration: 5,
	extra_fields: [
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_PATIENT_COMPLEXITY',
	name: 'Patient Complexity',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const ReferralNoteTaskType: TaskTypeDefinition = {
	default_duration: 0,
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FHIRQuestionnaireResponse',
			fields: FHIRQuestionnaireResponse,
			key: 'questionnaire_responses',
			label: 'Questionnaire',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralMentalStatusExamCreateUpdate',
			fields: BehavioralMentalStatusExamCreateUpdate,
			key: 'mental_status_exam',
			label: 'Mental Status Exam',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: false,
	key: 'REFERRAL_NOTE',
	name: 'Referral Note',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const DischargeSummaryNoteTaskType: TaskTypeDefinition = {
	default_duration: 0,
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FHIRQuestionnaireResponse',
			fields: FHIRQuestionnaireResponse,
			key: 'questionnaire_responses',
			label: 'Questionnaire',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'BehavioralMentalStatusExamCreateUpdate',
			fields: BehavioralMentalStatusExamCreateUpdate,
			key: 'mental_status_exam',
			label: 'Mental Status Exam',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: false,
	key: 'DISCHARGE_SUMMARY_NOTE',
	name: 'Discharge Summary Note',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const CarePlanManagementCcmInitiatingReviewTaskType: TaskTypeDefinition = {
	default_duration: 5,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_CCM_INITIATING_REVIEW',
	name: 'Initiating Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_VCM_LITE',
	],
};

export const AdmissionTaskTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Lab Test Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: false,
	key: 'ADMISSION_TASK',
	name: 'Transition of Care Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_VCM_LITE',
	],
};

export const AdmissionReviewTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'HistoryOfPresentIllness',
			fields: HistoryOfPresentIllness,
			key: 'history_of_present_illness',
			label: 'History of Present Illness',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'EventReview',
			fields: EventReview,
			key: 'event_review',
			label: 'Hx from Nursing / Family',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'OrderReview',
			fields: OrderReview,
			key: 'order_review',
			label: 'EMR Order Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PastMedicalHx',
			fields: PastMedicalHx,
			key: 'past_medical_hx',
			label: 'Past Medical Hx',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'SocialHistory',
			fields: SocialHistory,
			key: 'social_history',
			label: 'Social History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'FamilyHistory',
			fields: FamilyHistory,
			key: 'family_history',
			label: 'Family History',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImagingResultReviewCreateUpdate',
			fields: ImagingResultReviewCreateUpdate,
			key: 'imaging_result_review',
			label: 'Imaging Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ClinicalTestResultReviewCreateUpdate',
			fields: ClinicalTestResultReviewCreateUpdate,
			key: 'clinical_test_result_review',
			label: 'Clinical Test Result Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ReviewOfSystems',
			fields: ReviewOfSystems,
			key: 'review_of_systems',
			label: 'Review of Systems',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VitalExamination',
			fields: VitalExamination,
			key: 'vital_examination',
			label: 'Vital Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PhysicalExaminationCreateUpdate',
			fields: PhysicalExaminationCreateUpdate,
			key: 'physical_examination',
			label: 'Physical Examination',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'AssessmentPlan',
			fields: AssessmentPlan,
			key: 'assessment_plan',
			label: 'Assessment Plan',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientComplexity',
			fields: PatientComplexity,
			key: 'patient_complexity',
			label: 'Patient Complexity',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'VisitDetails',
			fields: VisitDetails,
			key: 'visit_details',
			label: 'Visit Details',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: true,
	is_visit: false,
	key: 'ADMISSION_REVIEW',
	name: 'Admission Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_VCM_LITE',
	],
};

export const ComplexCareCarePhysiologicalDataManagementTaskType: TaskTypeDefinition = {
	default_duration: 7,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'COMPLEX_CARE_CARE_PHYSIOLOGICAL_DATA_MANAGEMENT',
	name: 'Physiological Data Management (Remote)',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const CarePlanManagementComplexCareCarePlanReviewTaskType: TaskTypeDefinition = {
	default_duration: 15,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_COMPLEX_CARE_CARE_PLAN_REVIEW',
	name: 'Complex Care Plan Review, Update & Modification',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const CarePlanManagementCareTeamCoordinationTaskType: TaskTypeDefinition = {
	default_duration: 3,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_CARE_TEAM_COORDINATION',
	name: 'Care Team Coordination',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_NP_ALL',
		'ROLE_NP_ASSIGNED',
		'ROLE_VCM_LITE',
	],
};

export const CarePlanManagementPharmacyPlanReviewAntibioticsStewardshipTaskType: TaskTypeDefinition = {
	default_duration: 5,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_PHARMACY_PLAN_REVIEW_ANTIBIOTICS_STEWARDSHIP',
	name: 'Pharmacy Plan Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const CarePlanManagementReferralCoordinationReviewTaskType: TaskTypeDefinition = {
	default_duration: 9,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_REFERRAL_COORDINATION_REVIEW',
	name: 'Referral Coordination & Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
	],
};

export const CarePlanManagementProfConsultReviewOfTherapyPlanTaskType: TaskTypeDefinition = {
	default_duration: 8,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_PROF_CONSULT_REVIEW_OF_THERAPY_PLAN',
	name: 'Prof Consult Review of Therapy Plan',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const CarePlanManagementFamilyReviewAndConsultationTaskType: TaskTypeDefinition = {
	default_duration: 9,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT_FAMILY_REVIEW_AND_CONSULTATION',
	name: 'Family Review & Consultation',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const NewOrdersTaskType: TaskTypeDefinition = {
	default_duration: 5,
	extra_fields: [
		{
			_class: 'PhysicianOrder',
			fields: PhysicianOrder,
			key: 'physician_order',
			label: 'Orders',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'NEW_ORDERS',
	name: 'New Orders',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_BROADSTREET',
		'ROLE_SED_TESTING',
	],
};

export const ClinicalStatusReviewTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'ProblemList',
			fields: ProblemList,
			key: 'problem_list',
			label: 'Problem List',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'TreatmentReview',
			fields: TreatmentReview,
			key: 'treatment_review',
			label: 'Treatment Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'LabTestReview',
			fields: LabTestReview,
			key: 'lab_test_review',
			label: 'Results Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'PatientAllergyReviewCreateUpdate',
			fields: PatientAllergyReviewCreateUpdate,
			key: 'patient_allergy_review',
			label: 'Patient Allergy Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ImmunizationReviewCreateUpdate',
			fields: ImmunizationReviewCreateUpdate,
			key: 'immunization_review',
			label: 'Immunization Review',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'ProcedureReview',
			fields: ProcedureReview,
			key: 'procedure_review',
			label: 'Procedure Review',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CLINICAL_STATUS_REVIEW',
	name: 'Clinical Status Review',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_BROADSTREET',
		'ROLE_SED_TESTING',
		'ROLE_VCM_LITE',
	],
};

export const CarePlanManagementTaskType: TaskTypeDefinition = {
	children: [
		ClinicalStatusReviewTaskType,
		NewOrdersTaskType,
		CarePlanManagementFamilyReviewAndConsultationTaskType,
		CarePlanManagementProfConsultReviewOfTherapyPlanTaskType,
		CarePlanManagementReferralCoordinationReviewTaskType,
		CarePlanManagementPharmacyPlanReviewAntibioticsStewardshipTaskType,
		CarePlanManagementCareTeamCoordinationTaskType,
		CarePlanManagementComplexCareCarePlanReviewTaskType,
		ComplexCareCarePhysiologicalDataManagementTaskType,
		AdmissionReviewTaskType,
		AdmissionTaskTaskType,
		CarePlanManagementCcmInitiatingReviewTaskType,
		DischargeSummaryNoteTaskType,
		ReferralNoteTaskType,
		CarePlanManagementPatientComplexityTaskType,
		CarePlanManagementOnCallSummaryTaskType,
		ChartAuditTaskType,
		BehavioralChartAuditTaskType,
		TherapeuticInteractionReviewTaskType,
		PatientAccessManagementTaskType,
		PcmReviewTaskType
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'CARE_PLAN_MANAGEMENT',
	name: 'Care Plan Management',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_PHYSICIAN_CCM_ONLY',
		'ROLE_PHYSICIAN_TEAM_MEMBER_CCM_ONLY',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_SUBSPECIALIST_VCM_ONLY',
		'ROLE_SUBSPECIALIST_ACCESS_ONLY',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
	],
};

export const FacilityStaffContactWithCareTeamTaskType: TaskTypeDefinition = {
	default_duration: 3,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'FACILITY_STAFF_CONTACT_WITH_CARE_TEAM',
	name: 'Staff - Contact with Care Team',
	need_to_fax: false,
	need_to_sms: false,
};

export const FacilityLeadershipContactWithCareTeamTaskType: TaskTypeDefinition = {
	default_duration: 3,
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'FACILITY_LEADERSHIP_CONTACT_WITH_CARE_TEAM',
	name: 'Leadership - Contact with Care Team',
	need_to_fax: false,
	need_to_sms: false,
};

export const FacilityTaskType: TaskTypeDefinition = {
	children: [
		FacilityLeadershipContactWithCareTeamTaskType,
		FacilityStaffContactWithCareTeamTaskType
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'FACILITY',
	name: 'Facility',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_NURSING_DIRECTOR',
		'ROLE_SUPER_ADMIN',
		'ROLE_FREEMIUM_ALL_NURSING_DIRECTOR',
		'ROLE_FREEMIUM_ALL_ADMIN',
		'ROLE_FREEMIUM_ALL_USER',
		'ROLE_ARSANA_LITE',
		'ROLE_PHARMACY_CONSULTANT',
		'ROLE_NP_ALL',
		'ROLE_NP_ASSIGNED',
	],
};

export const DemographicsTaskType: TaskTypeDefinition = {
	extra_fields: [
		{
			_class: 'PatientInformation',
			fields: PatientInformation,
			key: 'patient_information',
			label: 'Patient Information',
			multiple: false,
			required: false,
			type: 'field_set',
		},
		{
			_class: 'Demographics',
			fields: Demographics,
			key: 'demographics',
			label: 'Demographics',
			multiple: false,
			required: false,
			type: 'field_set',
		}
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'DEMOGRAPHICS',
	name: 'Demographics',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_BROADSTREET',
		'ROLE_SED_TESTING',
		'ROLE_PHYSICIAN_TEAM_PROBATION',
	],
};

export const PatientDetailsTaskType: TaskTypeDefinition = {
	children: [
		DemographicsTaskType
	],
	is_behavioral: false,
	is_progress_note: false,
	is_visit: false,
	key: 'PATIENT_DETAILS',
	name: 'Patient Details',
	need_to_fax: false,
	need_to_sms: false,
	roles: [
		'ROLE_ARSANA_PHYSICIAN_ENCOUNTERS',
		'ROLE_PHYSICIAN',
		'ROLE_PHYSICIAN_NO_EMR',
		'ROLE_PHYSICIAN_TEAM_MEMBER',
		'ROLE_GPC_NARRATIVE_PHYSICIAN',
		'ROLE_PHYSICIAN_TEAM_INTERMEDIATE',
		'ROLE_BEHAVIORAL_PHYSICIAN',
		'ROLE_SUBSPECIALIST',
		'ROLE_ACO_CLINICAL_OVERSIGHT',
		'ROLE_BROADSTREET',
		'ROLE_SED_TESTING',
	],
};

export const TASK_TYPE_DEFINITIONS: TaskTypeDefinition[] = [
	RemoteMonitorTaskType,
	VisitTaskType,
	InPersonTaskType,
	CarePlanManagementTaskType,
	FacilityTaskType,
	PatientDetailsTaskType
];
